import { getIntl } from "../locales";
// carousel images
import AnalyticTool from "images/slider/goopter-analytic-tools.png";
import AllPlatform from "images/slider/goopter-digital-ordering-solution.png";
import FreeMobile from "images/slider/goopter-free-consumer-mobile-app.png";
import ProcessDiagram from "images/slider/goopter-goopter-process-diagram.jpg";
import NoDownload from "images/slider/goopter-no-download-instant-ordering.png";
import RestaurantAuto from "images/slider/goopter-restaurant-automation.jpg";
import AppStore from "images/slider/app-store.png";
import GooglePlay from "images/slider/google-play.png";

// Kiosk
import HeroImage from "images/kiosk/goopter-kiosk-mockup.jpg";
import TraditionalKiosk from "images/kiosk/traditional-kiosk.jpg";
import OwnDevices from "images/kiosk/use-your-own-devices.jpg";
import CustomizedLayout from "images/kiosk/store-layouts.png";
import Payment from "images/kiosk/payment-partners.jpg";
import OrderAtKiosk from "images/kiosk/order-at-kiosk.jpg";
import OrderAtTable from "images/kiosk/order-at-table.jpg";
import SaveTime from "images/kiosk/Icons/save-time.svg";
import AutoPrinting from "images/kiosk/Icons/automatic-printing.svg";
import GoopterApp from "images/kiosk/Icons/goopter-app.svg";
import NoMenus from "images/kiosk/Icons/no-menus.svg";
import CS from "images/kiosk/Icons/customer-satisfaction.svg";

// POS Devices
import CloverFlex from "images/pos/CloverFlex.jpg";
import CloverMini from "images/pos/CloverMini.jpg";
import CloverStationDuo from "images/pos/CloverStationDuo.jpg";
import CloverStationSolo from "images/pos/CloverStationSolo.jpg";
import KitchenDisplaySystem from "images/pos/KitchenDisplaySystem.jpg";
// import SelfServiceKiosk from "images/pos/Self-ServiceKiosk.jpg";
import SelfServiceKiosk from "images/pos/self-service-kiosk-img/SelfServiceKiosk.jpeg"; 
import CloverFlex0 from "images/pos/clover_flex_img/CloverFlex0.jpg";
import CloverFlex1 from "images/pos/clover_flex_img/CloverFlex1.png";
import CloverFlex2 from "images/pos/clover_flex_img/CloverFlex2.png";
import CloverFlex3 from "images/pos/clover_flex_img/CloverFlex3.png";
import CloverFlex4 from "images/pos/clover_flex_img/CloverFlex4.png";
import CloverFlex5 from "images/pos/clover_flex_img/CloverFlex5.png";
import CloverFlex6 from "images/pos/clover_flex_img/CloverFlex6.png";
import CloverFlex7 from "images/pos/clover_flex_img/CloverFlex7.png";
import CloverFlex8 from "images/pos/clover_flex_img/CloverFlex8.png";

import CloverMini0 from "images/pos/clover_mini_img/CloverMini0.jpg";
import CloverMini1 from "images/pos/clover_mini_img/CloverMini1.png";
import CloverMini2 from "images/pos/clover_mini_img/CloverMini2.png";
import CloverMini3 from "images/pos/clover_mini_img/CloverMini3.png";
import CloverMini4 from "images/pos/clover_mini_img/CloverMini4.png";
import CloverMini5 from "images/pos/clover_mini_img/CloverMini5.png";
import CloverMini6 from "images/pos/clover_mini_img/CloverMini6.png";
import CloverMini7 from "images/pos/clover_mini_img/CloverMini7.png";
import CloverMini8 from "images/pos/clover_mini_img/CloverMini8.png";
import CloverMini9 from "images/pos/clover_mini_img/CloverMini9.png";
import CloverMini10 from "images/pos/clover_mini_img/CloverMini10.png";
import CloverMini11 from "images/pos/clover_mini_img/CloverMini11.png";

import CloverStationDuo0 from "images/pos/clover_station_duo_img/CloverStationDuo0.jpg";
import CloverStationDuo1 from "images/pos/clover_station_duo_img/CloverStationDuo1.png";
import CloverStationDuo2 from "images/pos/clover_station_duo_img/CloverStationDuo2.png";
import CloverStationDuo3 from "images/pos/clover_station_duo_img/CloverStationDuo3.png";
import CloverStationDuo4 from "images/pos/clover_station_duo_img/CloverStationDuo4.png";
import CloverStationDuo5 from "images/pos/clover_station_duo_img/CloverStationDuo5.png";
import CloverStationDuo6 from "images/pos/clover_station_duo_img/CloverStationDuo6.png";
import CloverStationDuo7 from "images/pos/clover_station_duo_img/CloverStationDuo7.png";
import CloverStationDuo8 from "images/pos/clover_station_duo_img/CloverStationDuo8.png";
import CloverStationDuo9 from "images/pos/clover_station_duo_img/CloverStationDuo9.png";

import CloverStationSolo0 from "images/pos/clover_station_solo_img/CloverStationSolo0.jpg";
import CloverStationSolo1 from "images/pos/clover_station_solo_img/CloverStationSolo1.png";
import CloverStationSolo2 from "images/pos/clover_station_solo_img/CloverStationSolo2.png";
import CloverStationSolo3 from "images/pos/clover_station_solo_img/CloverStationSolo3.png";
import CloverStationSolo4 from "images/pos/clover_station_solo_img/CloverStationSolo4.png";
import CloverStationSolo5 from "images/pos/clover_station_solo_img/CloverStationSolo5.png";
import CloverStationSolo6 from "images/pos/clover_station_solo_img/CloverStationSolo6.png";
import CloverStationSolo7 from "images/pos/clover_station_solo_img/CloverStationSolo7.png";


import KitchenDisplaySystem0 from "images/pos/kitchen-display-system-img/KitchenDisplaySystem0.jpg";
import KitchenDisplaySystem1 from "images/pos/kitchen-display-system-img/KitchenDisplaySystem1.jpg";
import KitchenDisplaySystem2 from "images/pos/kitchen-display-system-img/KitchenDisplaySystem2.png";
import KitchenDisplaySystem3 from "images/pos/kitchen-display-system-img/KitchenDisplaySystem3.png";
import KitchenDisplaySystem4 from "images/pos/kitchen-display-system-img/KitchenDisplaySystem4.jpg";

import SelfServiceKiosk0 from "images/pos/self-service-kiosk-img/SelfServiceKiosk0.jpg";
// import SelfServiceKiosk1 from "images/pos/self-service-kiosk-img/SelfServiceKiosk1.jpg";
import SelfServiceKiosk1 from "images/pos/self-service-kiosk-img/SelfServiceKiosk1.jpeg";
// import SelfServiceKiosk2 from "images/pos/self-service-kiosk-img/SelfServiceKiosk2.jpg";
import SelfServiceKiosk2 from "images/pos/self-service-kiosk-img/SelfServiceKiosk2.jpeg";
// import SelfServiceKiosk3 from "images/pos/self-service-kiosk-img/SelfServiceKiosk3.jpg";
import SelfServiceKiosk3 from "images/pos/self-service-kiosk-img/SelfServiceKiosk3.jpeg";
// import SelfServiceKiosk4 from "images/pos/self-service-kiosk-img/SelfServiceKiosk4.png"; modified
import SelfServiceKiosk5 from "images/pos/self-service-kiosk-img/SelfServiceKiosk5.png";
import SelfServiceKiosk6 from "images/pos/self-service-kiosk-img/SelfServiceKiosk6.png";
// import SelfServiceKiosk6 from "images/pos/self-service-kiosk-img/SelfServiceKiosk6.jpeg";
import SelfServiceKiosk7 from "images/pos/self-service-kiosk-img/SelfServiceKiosk7.png";
import SelfServiceKiosk12 from "images/pos/self-service-kiosk-img/SelfServiceKiosk7.jpeg";
import SelfServiceKiosk8 from "images/pos/self-service-kiosk-img/SelfServiceKiosk8.png";
import SelfServiceKiosk13 from "images/pos/self-service-kiosk-img/SelfServiceKiosk13.jpeg"; 
import SelfServiceKiosk14 from "images/pos/self-service-kiosk-img/SelfServiceKiosk14.jpeg"; 

//Browse by use cases
import BrowseByUseCaseXCcart from "images/browseByUseCases/x-Cart-p-500.png";
import BrowseByUseCaseWooCommerce from "images/browseByUseCases/wooCommerce.png";
import BrowseByUseCaseVolusion from "images/browseByUseCases/volusion.png";
import BrowseByUseCaseSimpleCheckout from "images/browseByUseCases/simple Checkout.png";
import BrowseByUseCaseShopify from "images/browseByUseCases/shopify.png";
import BrowseByUseCaseRecurly from "images/browseByUseCases/recurly.png";
import BrowseByUseCaseQuote from "images/browseByUseCases/quote.png";
import BrowseByUseCasePrestaShop from "images/browseByUseCases/prestaShop.png";
import BrowseByUseCaseOpenCart from "images/browseByUseCases/openCart.png";
import BrowseByUseCaseMivaEcommercePlatform from "images/browseByUseCases/miva-Ecommerce-Platform.png";
import BrowseByUseCaseMagento from "images/browseByUseCases/magento.png";
import BrowseByUseCaseInvoicera from "images/browseByUseCases/invoicera.png";
import BrowseByUseCaseEcwid from "images/browseByUseCases/ecwid.png";
// import BrowseByUseCaseCustomers from "images/browseByUseCases/customers.png"; modified
import BrowseByUseCaseCloverVirtualTerminal from "images/browseByUseCases/cloverVirtualTerminal.png";
import BrowseByUseCaseCloverMini from "images/browseByUseCases/clover-mini.png";
import BrowseByUseCaseCloverFlex from "images/browseByUseCases/clover-flex.png";
import BrowseByUseCaseChargify from "images/browseByUseCases/chargify.png";
import BrowseByUseCaseBigCommerce from "images/browseByUseCases/bigCommerce-p-500.png";
import BrowseByUseCaseBamboraVirtualTerminal from "images/browseByUseCases/bamboraVirtualTerminal.png";
import BrowseByUseCaseBamboraApi from "images/browseByUseCases/bambora-api.png";
import BrowseByUseCaseAuthorize from "images/browseByUseCases/authorize.png";

// service rate
import ServiceRate from "images/serviceRate/pricingChart.png";


// Software Solution
import Automate from "images/goopter-automate-ordering.jpg";
import OnlineBland from "images/goopter-own-your-online-brand.jpg";
import Software from "images/goopter-software-solutions.png";
import EcommerceOnlineOrdering from "images/goopter-ecommerce-branded-online-ordering.jpg";
import CustomerDatabase from "images/goopter-ecommerce-customer-database.png";
import LoyaltyGiftCard from "images/goopter-ecommerce-rewards-loyalty-giftcards.png";
import CustomerReview from "images/goopter-ecommerce-customer-reviews.png";
import GuidanceResources from "images/goopter-ecommerce-guidance-resources.jpg";
import EcommerceSelfOrdering from "images/goopter-ecommerce-self-ordering-scenarios.png";
import EcommercePayments from "images/goopter-ecommerce-multiple-payments.jpg";
import EcommerceAutoPrint from "images/goopter-ecommerce-automatic-printing.jpg";
import EcommercePremise from "images/goopter-ecommerce-off-premise-operations.png";
import StaffPosOrdering from "images/goopter-staff-pos-ordering.jpg";
import EcommercePayTransfer from "images/goopter-ecommerce-direct-payment-transfers.jpg";

//About us
import { ReactComponent as Mission } from "images/goopter-about-us-our-mission.svg";
import { ReactComponent as Logo } from "images/goopter_logo_rgb.svg";

// pricing
import including1 from "images/pricing/goopter-ecommerce-domain-name.png";
import including2 from "images/pricing/goopter-ecommerce-e-gift-cards.png";
import including3 from "images/pricing/goopter-ecommerce-mobile-business-management.png";
import including4 from "images/pricing/goopter-ecommerce-multi-language.png";
import including5 from "images/pricing/goopter-ecommerce-online-payment.png";
import including6 from "images/pricing/goopter-ecommerce-automatic-printing.png";
import including7 from "images/pricing/goopter-ecommerce-technical-support.png";
import including8 from "images/pricing/goopter-ecommerce-customer-data.png";
import including9 from "images/pricing/goopter-ecommerce-risk-free-zero-monthly-fee.png";
import including10 from "images/pricing/goopter-ecommerce-discount-codes.png";
import including11 from "images/pricing/goopter-ecommerce-user-friendly.png";
import including12 from "images/pricing/goopter-ecommerce-affordable-service-fees.png";

// Signup
import { ReactComponent as Website } from "images/icons/website-svgrepo-com.svg";
import { ReactComponent as Search } from "images/icons/people-searcher.svg";
import { ReactComponent as MultiDivice } from "images/icons/tablet-smartphone-computer.svg";

// features
import { ReactComponent as FeatureWebsite } from "images/icons/website.svg";
import { ReactComponent as Customer } from "images/icons/users.svg";
import { ReactComponent as Management } from "images/icons/clipboard-svgrepo-com.svg";
import { ReactComponent as Smartphone } from "images/icons/smartphone.svg";
import { ReactComponent as Discount } from "images/icons/discount.svg";
import { ReactComponent as Account } from "images/icons/account.svg";

import EcommerceSocialShare from "images/goopter-ecommerce-social-share.png";
import EcommerceMultiLang from "images/goopter-ecommerce-multi-language.png";
import { ReactComponent as LangSvgRepo } from "images/icons/language.svg";
import SeoEcommerce from "images/goopter-ecommerce-seo.jpg";

// robot pages
import BellaRobot from "images/goopter-robots-bellabot.jpg";
import DisinfectionRobot from "images/goopter-robots-disinfection.png";
import Pudubot from "images/goopter-pudubot.png";
import FlashBot from "images/robots/goopter-hardware-flashbot.jpg";
import PuduBot from "images/goopter-pudubot.png";
import PromoBot from "images/robots/goopter-hardware-solution-promobot.jpg";
import BellaBot from "images/goopter-robots-bellabot.jpg";

import Innovative from "images/robots/goopter-promobot-display-ads.jpg";
import Specialized from "images/robots/goopter-promobot-screen-advertisment-promotions.jpg";

import Smart from "images/robots/goopter-promobot-smart-delivery.png";
import Dining from "images/goopter-popular-use-case-dining-automation.jpg";
import Casino from "images/goopter-popular-use-case-casinos.jpg";
import Retail from "images/goopter-popular-use-case-retail-stores.jpg";
import Hotel from "images/robots/goopter-hardware-hotel-use-case.jpg";

import GuestInter from "images/robots/goopter-bellabot-smart-expressions.png";
import BellaBotSpec from "images/robots/goopter-bellabot-specifications.png";
import BellaBotFood from "images/robots/goopter-bellabot-food-delivery.jpg";
import Hospital from "images/robots/goopter-disinfection-robot-hospital-use-case.jpg";

import DisinfectionCharge from "images/robots/goopter-disinfection-robot-automatic-charging.png";
import DisinfectionSensors from "images/robots/goopter-disinfection-robot-sensors.png";
import MultiDisinfection from "images/robots/goopter-disinfection-robot-sterilization-modes.jpg";
import Intelligent from "images/robots/goopter-pudubot-intelligent-efficient.png";
import Superior from "images/robots/goopter-pudubot-capabilities.png";
import Obstacle from "images/robots/goopter-pudubot-3d-obstacle-avoidance.jpg";
import Works from "images/robots/goopter-pudubot-tray-options.png";
import FlashTop from "images/robots/goopter-flashbot-building-delivery.jpg";
import FlashNextGeneration from "images/robots/goopter-flashbot-building-delivery-sensors.jpg";
import FlashSpecialized from "images/robots/goopter-flashbot-taking-elevator.jpg";
import FlashSpec from "images/goopter-flashbot-building-delivery-spec.jpeg";
import Safe from "images/goopter-flashbot-modular-compartments.jpg";
import PuduSpecification from "images/robots/goopter-pudubot-specifications.png";
import BellaIntro from "images/robots/goopter-bellabot-features.png";

export function getData(name) {

  const intl = getIntl();
  const str = (id, values) => intl.formatMessage({ id }, values);
  const formatMessages = (ids) => ids.map(id => intl.formatMessage({ id }));


  const navModal = {
    46: [
      //46
      {
        id: 1,
        title: str("acquire_new_customers"),
        contents: str("nav_modal_contents1"),
        imgUrl: "",
        link: "/acquire-new-customers",
        color: "primary",
        buttonText: str("learn_more"),
      },
      {
        id: 2,
        title: str("own_your_online_brand"),
        contents: str("nav_modal_contents2"),
        imgUrl: "",
        link: "/own-your-online-brand",
        color: "accent",
        buttonText: str("learn_more"),
      },
      {
        id: 3,
        title: str("automate_your_ordering_process"),
        contents: str("nav_modal_contents3"),
        imgUrl: "",
        link: "/automate-order-process",
        color: "primary",
        buttonText: str("learn_more"),
      },
    ],
    47: [
      //47
      {
        id: 1,
        renderId: "navModal1",
        title: str("nav_modal_title4"),
        contents: str("nav_modal_contents4"),
        contents2: str("nav_modal_contents4_2"),
        link: "/bellabot-restaurant-delivery-robot",
        color: "accent",
        imgUrl: BellaRobot,
        buttonText: str("explore"),
        description: str("nav_modal_desc4"),
        description2: str("nav_modal_desc4_2"),
      },
      {
        id: 2,
        renderId: "navModal2",
        title: str("nav_modal_title5"),
        contents: str("nav_modal_contents5"),
        contents2: str("nav_modal_contents5_2"),
        link: "/pudubot-food-delivery-robot",
        color: "accent",
        imgUrl: Pudubot,
        buttonText: str("explore"),
        description: str("nav_modal_desc5"),
        description2: str("nav_modal_desc5_2"),
      },
      {
        id: 3,
        renderId: "navModal3",
        title: str("nav_modal_title6"),
        contents: str("nav_modal_contents6"),
        contents2: str("nav_modal_contents6_2"),
        link: "/disinfectionbot-autonomous-disinfection-robot",
        color: "accent",
        imgUrl: DisinfectionRobot,
        buttonText: str("explore"),
        description: str("nav_modal_desc6"),
        description2: str("nav_modal_desc6_2"),
      },
    ],
  };

  const carouselData = [
    {
      id: "carouselData1",
      title: str("carousel_data_title1"),
      text: str("carousel_data_text1"),
      videoUrl: "https://player.vimeo.com/video/648786573?h=1a8b91dc7c",
      buttonText: str("learn_more"),
      buttonLink: "/software-solution",
    },
    {
      id: "carouselData2",
      title: str("carousel_data_title2"),
      text: str("carousel_data_text2"),
      imgUrl: RestaurantAuto,
      buttonText: str("learn_more"),
      buttonLink: "/use-case-dining-automation",
    },
    {
      id: "carouselData3",
      title: str("carousel_data_title3"),
      text: str("carousel_data_text3"),
      imgUrl: NoDownload,
      buttonText: str("learn_more"),
      buttonLink: "/software-solution",
    },
    {
      id: "carouselData4",
      title: str("carousel_data_title4"),
      text: str("carousel_data_text4"),
      imgUrl: AnalyticTool,
      buttonText: str("learn_more"),
      buttonLink: "/software-solution",
    },
    {
      id: "carouselData5",
      title: str("carousel_data_title5"),
      text: str("carousel_data_text5"),
      imgUrl: AllPlatform,
      buttonText: str("learn_more"),
      buttonLink: "/software-solution",
    },
    {
      id: "carouselData6",
      title: str("carousel_data_title6"),
      text: "",
      imgUrl: ProcessDiagram,
      buttonText: str("learn_more"),
      buttonLink: "/software-solution",
    },
    {
      id: "carouselData7",
      title: str("carousel_data_title7"),
      text: str("carousel_data_text7"),
      imgUrl: FreeMobile,
      buttonImage: AppStore,
      buttonLink: "https://apps.apple.com/ca/app/goopter/id1082587203",
      button2Image: GooglePlay,
      button2Link:
        "https://play.google.com/store/apps/details?id=com.goopter.diyorder&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
    },
  ];

  const bellabotCarousel = [
    {
      videoUrl: "https://player.vimeo.com/video/642488495?h=4d05918d24",
    },
    {
      videoUrl: "https://player.vimeo.com/video/642530077?h=c8d85ff772",
    },
  ];

  const bellabotVideo = [
    {
      videoUrl: "https://player.vimeo.com/video/642529933?h=b539d7ac59",
    },
  ];

  const promobotCarousel = [
    {
      videoUrl: "https://player.vimeo.com/video/642774291?h=ad5645cda8",
    },
    {
      videoUrl: "https://player.vimeo.com/video/642774227?h=e594b60fb2",
    },
  ];
  const pudubotCarousel = [
    {
      videoUrl: "https://vimeo.com/642774465",
    },
  ];

  const disinfectiontCarousel = [
    {
      // videoImage: RobotVideoImage,
      videoUrl: "https://vimeo.com/642774115",
    },
  ];

  const useCaseData = [
    {
      title: str("restaurant_ordering"),
      id: 1,
      desc: [
        str("usecase_restaurant_ordering_text1"),
        str("usecase_restaurant_ordering_text2"),
      ],

      link: "use-case-restaurant-ordering-solution",
    },
    {
      title: str("dining_automation"),
      id: 2,
      desc: [
        str("usecase_dining_automation_text1"),
        str("usecase_dining_automation_text2"),
      ],
      link: "/use-case-dining-automation",
    },
    {
      title: str("retail_stores"),
      id: 3,
      desc: [
        str("usecase_retail_stores_text1"),
        str("usecase_retail_stores_text2"),
      ],
      link: "/use-case-retail-store-automation",
    },
    {
      title: str("hotel_service_automation"),
      id: 4,
      desc: [
        str("usecase_hotel_service_automation_text1"),
        str("usecase_hotel_service_automation_text2"),
        str("usecase_hotel_service_automation_text3"),
      ],
      link: "/use-case-hotel-service-automation",
    },
    {
      title: str("casino_food_drink_automation"),
      id: 5,
      desc: [
        str("usecase_casino_food_drink_automation_text1"),
        str("usecase_casino_food_drink_automation_text2"),
      ],

      link: "/use-case-movie-theatre-ordering",
    },
    {
      title: str("movie_theatres"),
      id: 6,
      desc: [
        str("usecase_movie_theatres_text1"),
        str("usecase_movie_theatres_text2"),
      ],

      link: "/use-case-casino-food-drink-automation",
    },
  ];

  //use case pos Devices Data
  const posDevicesData = [
    {
      title: str("clover_flex"),
      id: 1,
      desc: [
        str("usecase_clover_flex_text1"),
        str("usecase_clover_flex_text2"),
      ],
      link: "pos-device-clover-flex",
      img: CloverFlex,
    },
    {
      title: str("clover_mini"),
      id: 2,
      desc: [
        str("usecase_clover_mini_text1"),
      ],
      link: "pos-device-clover-mini",
      img: CloverMini,
    },
    {
      title: str("clover_station_duo"),
      id: 3,
      desc: [
        str("usecase_clover_station_duo_text1"),
        str("usecase_clover_station_duo_text2"),
      ],
      link: "pos-device-clover-station-duo",
      img: CloverStationDuo,
    },
    {
      title: str("clover_station_solo"),
      id: 4,
      desc: [
        str("usecase_clover_station_solo_text1"),
      ],
      link: "pos-device-clover-station-solo",
      img: CloverStationSolo,
    },
    {
      title: str("kitchen_display_system"),
      id: 5,
      desc: [
        str("usecase_kitchen_display_system_text1"),
        str("usecase_kitchen_display_system_text2"),
      ],
      link: "pos-device-kitchen-display-system",
      img: KitchenDisplaySystem,
    },
    {
      title: str("self_service_kiosk"),
      id: 6,
      desc: [
        str("usecase_self_service_kiosk_text1"),
        str("usecase_self_service_kiosk_text2"),
      ],
      link: "pos-device-self-service-kiosk",
      img: SelfServiceKiosk,
    },
  ];


  const careers = {
    header: {
      title: str("careers_title"),
      text: [str("careers_text"), str("careers_text1_2")],
      svg: Logo,
    },
    positions: {
      title: str("careers_positions_title"),
      contents: [
        {
          id: 1,
          title: str("careers_positions2_title"),
          desc: [str("careers_positions2_text")],
        },
        {
          id: 2,
          title: str("careers_positions1_title"),
          desc: [str("careers_positions1_text")],
        },
      ],
    },
  };

  const kioskData = [
    {
      id: 1,
      renderId: "kioskData1",
      title: str("kiosk_title"),
      text: str("kiosk_title_p"),
      link: "/use-case-self-order-kiosk",
      img: HeroImage,
    },
    {
      id: 2,
      renderId: "kioskData2",
      banner_title: str("kiosk_banner_title"),
      banner_paragraph: [str("kiosk_banner_p")],
      features: [
        {
          title: str("kiosk_features_title"),
          text: str("kiosk_features_p_1"),
          sub_text: str("kiosk_features_p_2"),
          img: TraditionalKiosk,
        },
      ],
      solutions_title: str("kiosk_solutions_title"),
      solutions: [
        {},
        {
          title: str("kiosk_solutions_1_title"),
          text: [str("kiosk_solutions_1_p")],
          text_bold: str("kiosk_solutions_1_p_highlight"),
          img: OwnDevices,
        },
        {
          title: str("kiosk_solutions_2_title"),
          text: [str("kiosk_solutions_2_p")],
          text_bold: str("kiosk_solutions_2_p_highlight"),
          img: CustomizedLayout,
        },
        {
          title: str("kiosk_solutions_3_title"),
          text: [str("kiosk_solutions_3_p")],
          text_bold: str("kiosk_solutions_3_p_highlight"),
          img: Payment,
        },
      ],
      benefits_title: str("kiosk_benefits_title"),
      benefits: [
        {
          title: str("kiosk_benefits_1"),
          img: SaveTime,
        },
        {
          title: str("kiosk_benefits_2"),
          img: AutoPrinting,
        },
        {
          title: str("kiosk_benefits_3"),
          img: GoopterApp,
        },
        {
          title: str("kiosk_benefits_4"),
          img: NoMenus,
        },
        {
          title: str("kiosk_benefits_5"),
          img: CS,
        },
      ],
      options_title: str("kiosk_options_title"),
      options: [
        {
          title: str("kiosk_options_1_title"),
          text: str("kiosk_options_1_p"),
          img: OrderAtKiosk,
        },
        {
          title: str("kiosk_options_2_title"),
          text: str("kiosk_options_2_p"),
          img: OrderAtTable,
        },
      ],
    },
  ];

  const serviceRateData = [
    {
      id: 1,
      renderId: "serviceRateData",
      title: str("service_rate_title"),
      text: formatMessages([
        "service_rate_text_1",
        "service_rate_text_2",
        "service_rate_text_3",
        "service_rate_text_4",
      ]),
      img: ServiceRate,
    }
  ]
  const serviceRatePageData = [
    {
      id: 1,
      renderId: "serviceRatePageData1",
      title: str("service_rate_data_1_title"),
      text: formatMessages([
        "service_rate_data_1_text_1",
        "service_rate_data_1_text_2",
        "service_rate_data_1_text_3",
        "service_rate_data_1_text_4",
        "service_rate_data_1_text_5",
        "service_rate_data_1_text_6",
        "service_rate_data_1_text_7",
        "service_rate_data_1_text_8",
        "service_rate_data_1_text_9",
        "service_rate_data_1_text_10",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData2",
      title: str("service_rate_data_2_title"),
      text: formatMessages([
        "service_rate_data_2_text_1",
        "service_rate_data_2_text_2",
        "service_rate_data_2_text_3",
      ]),
      img: "",
    },
    {
      id: 3,
      renderId: "serviceRatePageData3",
      title: str("service_rate_data_3_title"),
      text: formatMessages([
        "service_rate_data_3_text_1",
        "service_rate_data_3_text_2",
        "service_rate_data_3_text_3",
        "service_rate_data_3_text_4",
        "service_rate_data_3_text_5",
        "service_rate_data_3_text_6",
      ]),
      img: "",
    },

  ];
  const serviceRateIndustryPageData = [
    {
      id: 1,
      renderId: "serviceRatePageData1",
      title: str("service_rate_data_1_title"),
      text: formatMessages([
        "service_rate_data_1_text_1",
        "service_rate_data_1_text_2",
        "service_rate_data_1_text_3",
        "service_rate_data_1_text_4",
        "service_rate_data_1_text_5",
        "service_rate_data_1_text_6",
        "service_rate_data_1_text_7",
        "service_rate_data_1_text_8",
        "service_rate_data_1_text_9",
        "service_rate_data_1_text_10",
      ]),
      img: "",
    },
    {
      id: 2,
    },
    {
      id: 3,
      renderId: "serviceRatePageData3",
      title: str("service_rate_data_3_title"),
      text: formatMessages([
        "service_rate_data_3_text_1",
        "service_rate_data_3_text_2",
        "service_rate_data_3_text_3",
        "service_rate_data_3_text_4",
        "service_rate_data_3_text_5",
        "service_rate_data_3_text_6",
      ]),
      img: "",
    },

  ];
  //0-10k
  const industry_0_10k_data = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_0_10_text_1"),
      text: formatMessages([
        "service_rate_data_0_10_text_3",
        "service_rate_data_0_10_text_4",
        "service_rate_data_0_10_text_5",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_0_10_text_6"),
      text: formatMessages([
        "service_rate_data_0_10_text_7",
        "service_rate_data_0_10_text_8",
        "service_rate_data_0_10_text_9",
      ]),
      img: "",
    }
  ];
  //10-50k
  const industry_10_50k_auto_shop = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_title"),
      text: formatMessages([
        "service_rate_data_4_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_3",
        "service_rate_data_4_text_4",
        "service_rate_data_4_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_cannabis = [
    {
      id: 1,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_title"),
      text: formatMessages([
        "service_rate_data_5_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_text_2"),
      text: formatMessages([
        "service_rate_data_5_text_3",
        "service_rate_data_5_text_4",
        "service_rate_data_5_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_car_wash = [
    {
      id: 1,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_title"),
      text: formatMessages([
        "service_rate_data_6_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_text_2"),
      text: formatMessages([
        "service_rate_data_6_text_3",
        "service_rate_data_6_text_4",
        "service_rate_data_6_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_charities = [
    {
      id: 1,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_title"),
      text: formatMessages([
        "service_rate_data_15_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_text_2"),
      text: formatMessages([
        "service_rate_data_15_text_3",
        "service_rate_data_15_text_4",
        "service_rate_data_15_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_ecommerce = [
    {
      id: 1,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_title"),
      text: formatMessages([
        "service_rate_data_14_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_text_2"),
      text: formatMessages([
        "service_rate_data_14_text_3",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_gas_station = [
    {
      id: 1,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_title"),
      text: formatMessages([
        "service_rate_data_13_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_text_2"),
      text: formatMessages([
        "service_rate_data_13_text_3",
        "service_rate_data_13_text_4",
        "service_rate_data_13_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_grocery = [
    {
      id: 1,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_title"),
      text: formatMessages([
        "service_rate_data_12_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_text_2"),
      text: formatMessages([
        "service_rate_data_12_text_3",
        "service_rate_data_12_text_4",
        "service_rate_data_12_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_invoicing = [
    {
      id: 1,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_title"),
      text: formatMessages([
        "service_rate_data_11_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_text_2"),
      text: formatMessages([
        "service_rate_data_11_text_3",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_medical = [
    {
      id: 1,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_title"),
      text: formatMessages([
        "service_rate_data_10_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_text_2"),
      text: formatMessages([
        "service_rate_data_10_text_3",
        "service_rate_data_10_text_4",
        "service_rate_data_10_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_recurring_fees = [
    {
      id: 1,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_title"),
      text: formatMessages([
        "service_rate_data_9_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_text_2"),
      text: formatMessages([
        "service_rate_data_9_text_3",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_restaurants = [
    {
      id: 1,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_title"),
      text: formatMessages([
        "service_rate_data_8_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_text_2"),
      text: formatMessages([
        "service_rate_data_8_text_3",
        "service_rate_data_8_text_4",
        "service_rate_data_8_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_retail = [
    {
      id: 1,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_title"),
      text: formatMessages([
        "service_rate_data_7_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_text_2"),
      text: formatMessages([
        "service_rate_data_7_text_3",
        "service_rate_data_7_text_4",
        "service_rate_data_7_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_salons = [
    {
      id: 1,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_title"),
      text: formatMessages([
        "service_rate_data_19_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_text_2"),
      text: formatMessages([
        "service_rate_data_19_text_3",
        "service_rate_data_19_text_4",
        "service_rate_data_19_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_services = [
    {
      id: 1,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_title"),
      text: formatMessages([
        "service_rate_data_18_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_text_2"),
      text: formatMessages([
        "service_rate_data_18_text_3",
        "service_rate_data_18_text_4",
        "service_rate_data_18_text_5",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_taxi = [
    {
      id: 1,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_title"),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_text_1"),
      text: formatMessages([
        "service_rate_data_17_text_2",
        "service_rate_data_17_text_3",
        "service_rate_data_17_text_4",
      ]),
      img: "",
    }
  ];

  const industry_10_50k_variety_stores = [
    {
      id: 1,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_title"),
      text: formatMessages([
        "service_rate_data_16_text_1",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_text_2"),
      text: formatMessages([
        "service_rate_data_16_text_3",
        "service_rate_data_16_text_4",
        "service_rate_data_16_text_5",
      ]),
      img: "",
    }
  ];

  //50-100k
  const industry_50_100k_auto_shop = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_4_text_4",
        "service_rate_data_4_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_cannabis = [
    {
      id: 1,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_text_2"),
      text: formatMessages([
        "service_rate_data_5_text_6",
        "service_rate_data_5_text_4",
        "service_rate_data_5_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_car_wash = [
    {
      id: 1,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_6_text_4",
        "service_rate_data_6_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_charities = [
    {
      id: 1,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_15_text_4",
        "service_rate_data_15_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_ecommerce = [
    {
      id: 1,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_8",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_gas_station = [
    {
      id: 1,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_13_text_4",
        "service_rate_data_13_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_grocery = [
    {
      id: 1,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_12_text_4",
        "service_rate_data_12_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_invoicing = [
    {
      id: 1,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_8",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_medical = [
    {
      id: 1,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_10_text_4",
        "service_rate_data_10_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_recurring_fees = [
    {
      id: 1,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_8",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_restaurants = [
    {
      id: 1,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_8_text_4",
        "service_rate_data_8_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_retail = [
    {
      id: 1,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_7_text_4",
        "service_rate_data_7_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_salons = [
    {
      id: 1,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_19_text_4",
        "service_rate_data_19_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_services = [
    {
      id: 1,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_18_text_4",
        "service_rate_data_18_text_5",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_taxi = [
    {
      id: 1,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_title2"),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_text_1"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_17_text_3",
        "service_rate_data_17_text_4",
      ]),
      img: "",
    }
  ];

  const industry_50_100k_variety_stores = [
    {
      id: 1,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_title"),
      text: formatMessages([
        "service_rate_data_4_text_6",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_7",
        "service_rate_data_16_text_4",
        "service_rate_data_16_text_5",
      ]),
      img: "",
    }
  ];

  //100-250k

  const industry_100_250k_auto_shop = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_4_text_4",
        "service_rate_data_4_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_cannabis = [
    {
      id: 1,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_text_2"),
      text: formatMessages([
        "service_rate_data_5_text_12",
        "service_rate_data_5_text_4",
        "service_rate_data_5_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_car_wash = [
    {
      id: 1,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_6_text_4",
        "service_rate_data_6_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_charities = [
    {
      id: 1,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_15_text_4",
        "service_rate_data_15_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_ecommerce = [
    {
      id: 1,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_11",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_gas_station = [
    {
      id: 1,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_13_text_4",
        "service_rate_data_13_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_grocery = [
    {
      id: 1,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_12_text_4",
        "service_rate_data_12_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_invoicing = [
    {
      id: 1,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_11",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_medical = [
    {
      id: 1,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_10_text_4",
        "service_rate_data_10_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_recurring_fees = [
    {
      id: 1,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_11",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_restaurants = [
    {
      id: 1,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_8_text_4",
        "service_rate_data_8_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_retail = [
    {
      id: 1,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_7_text_4",
        "service_rate_data_7_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_salons = [
    {
      id: 1,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_19_text_4",
        "service_rate_data_19_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_services = [
    {
      id: 1,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_18_text_4",
        "service_rate_data_18_text_5",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_taxi = [
    {
      id: 1,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_title3"),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_text_1"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_17_text_3",
        "service_rate_data_17_text_4",
      ]),
      img: "",
    }
  ];

  const industry_100_250k_variety_stores = [
    {
      id: 1,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_title"),
      text: formatMessages([
        "service_rate_data_4_text_9",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_10",
        "service_rate_data_16_text_4",
        "service_rate_data_16_text_5",
      ]),
      img: "",
    }
  ];

  //250k-500k
  const industry_250_500k_auto_shop = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_4_text_4",
        "service_rate_data_4_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_cannabis = [
    {
      id: 1,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_text_2"),
      text: formatMessages([
        "service_rate_data_5_text_3",
        "service_rate_data_5_text_4",
        "service_rate_data_5_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_car_wash = [
    {
      id: 1,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_6_text_4",
        "service_rate_data_6_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_charities = [
    {
      id: 1,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_15_text_4",
        "service_rate_data_15_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_ecommerce = [
    {
      id: 1,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_15",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_gas_station = [
    {
      id: 1,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_13_text_4",
        "service_rate_data_13_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_grocery = [
    {
      id: 1,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_12_text_4",
        "service_rate_data_12_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_invoicing = [
    {
      id: 1,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_15",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_medical = [
    {
      id: 1,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_10_text_4",
        "service_rate_data_10_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_recurring_fees = [
    {
      id: 1,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_15",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_restaurants = [
    {
      id: 1,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_8_text_4",
        "service_rate_data_8_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_retail = [
    {
      id: 1,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_7_text_4",
        "service_rate_data_7_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_salons = [
    {
      id: 1,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_19_text_4",
        "service_rate_data_19_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_services = [
    {
      id: 1,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_18_text_4",
        "service_rate_data_18_text_5",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_taxi = [
    {
      id: 1,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_title4"),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_text_1"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_17_text_3",
        "service_rate_data_17_text_4",
      ]),
      img: "",
    }
  ];

  const industry_250_500k_variety_stores = [
    {
      id: 1,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_title"),
      text: formatMessages([
        "service_rate_data_4_text_13",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_14",
        "service_rate_data_16_text_4",
        "service_rate_data_16_text_5",
      ]),
      img: "",
    }
  ];

  //500k
  const industry_500k_auto_shop = [
    {
      id: 1,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData4",
      title: str("service_rate_data_4_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_4_text_4",
        "service_rate_data_4_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_cannabis = [
    {
      id: 1,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData5",
      title: str("service_rate_data_5_text_2"),
      text: formatMessages([
        "service_rate_data_5_text_18",
        "service_rate_data_5_text_4",
        "service_rate_data_5_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_car_wash = [
    {
      id: 1,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData6",
      title: str("service_rate_data_6_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_6_text_4",
        "service_rate_data_6_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_charities = [
    {
      id: 1,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData15",
      title: str("service_rate_data_15_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_15_text_4",
        "service_rate_data_15_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_ecommerce = [
    {
      id: 1,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData14",
      title: str("service_rate_data_14_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_19",
      ]),
      img: "",
    }
  ];

  const industry_500k_gas_station = [
    {
      id: 1,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData13",
      title: str("service_rate_data_13_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_13_text_4",
        "service_rate_data_13_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_grocery = [
    {
      id: 1,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData12",
      title: str("service_rate_data_12_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_12_text_4",
        "service_rate_data_12_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_invoicing = [
    {
      id: 1,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData11",
      title: str("service_rate_data_11_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_19",
      ]),
      img: "",
    }
  ];

  const industry_500k_medical = [
    {
      id: 1,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData10",
      title: str("service_rate_data_10_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_10_text_4",
        "service_rate_data_10_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_recurring_fees = [
    {
      id: 1,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData9",
      title: str("service_rate_data_9_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_19",
      ]),
      img: "",
    }
  ];

  const industry_500k_restaurants = [
    {
      id: 1,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData8",
      title: str("service_rate_data_8_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_8_text_4",
        "service_rate_data_8_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_retail = [
    {
      id: 1,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData7",
      title: str("service_rate_data_7_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_7_text_4",
        "service_rate_data_7_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_salons = [
    {
      id: 1,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData19",
      title: str("service_rate_data_19_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_19_text_4",
        "service_rate_data_19_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_services = [
    {
      id: 1,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData18",
      title: str("service_rate_data_18_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_18_text_4",
        "service_rate_data_18_text_5",
      ]),
      img: "",
    }
  ];

  const industry_500k_taxi = [
    {
      id: 1,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_title5"),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData17",
      title: str("service_rate_data_17_text_1"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_17_text_3",
        "service_rate_data_17_text_4",
      ]),
      img: "",
    }
  ];

  const industry_500k_variety_stores = [
    {
      id: 1,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_title"),
      text: formatMessages([
        "service_rate_data_4_text_17",
      ]),
      img: "",
    },
    {
      id: 2,
      renderId: "serviceRatePageData16",
      title: str("service_rate_data_16_text_2"),
      text: formatMessages([
        "service_rate_data_4_text_18",
        "service_rate_data_16_text_4",
        "service_rate_data_16_text_5",
      ]),
      img: "",
    }
  ];



  const serviceRatesIndustryFaqData = [
    {
      id: 1,
      renderId: "serviceRatePageFaqData1",
      title: {
        rendered: str("service_rate_industry_faq_data_1_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_1_text_1",
          "service_rate_industry_faq_data_1_text_2",
          "service_rate_industry_faq_data_1_text_3",
          "service_rate_industry_faq_data_1_text_4",
          "service_rate_industry_faq_data_1_text_5",
          "service_rate_industry_faq_data_1_text_6",
          "service_rate_industry_faq_data_1_text_7",
          "service_rate_industry_faq_data_1_text_8",
        ]),
      },
    },
    {
      id: 2,
      renderId: "serviceRatePageFaqData2",
      title: {
        rendered: str("service_rate_industry_faq_data_2_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_2_text_1",
        ]),
      },
    },
    {
      id: 3,
      renderId: "serviceRatePageFaqData3",
      title: {
        rendered: str("service_rate_industry_faq_data_3_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_3_text_1",
        ]),
      },
    },
    {
      id: 4,
      renderId: "serviceRatePageFaqData4",
      title: {
        rendered: str("service_rate_industry_faq_data_4_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_4_text_1",
          "service_rate_industry_faq_data_4_text_2",
          "service_rate_industry_faq_data_4_text_3",
          "service_rate_industry_faq_data_4_text_4",
          "service_rate_industry_faq_data_4_text_5",
          "service_rate_industry_faq_data_4_text_6",
          "service_rate_industry_faq_data_4_text_7",
        ]),
      },
    },
    {
      id: 5,
      renderId: "serviceRatePageFaqData5",
      title: {
        rendered: str("service_rate_industry_faq_data_5_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_5_text_1",
          "service_rate_industry_faq_data_5_text_2",
          "service_rate_industry_faq_data_5_text_3",
        ]),
      },
    },
    {
      id: 6,
      renderId: "serviceRatePageFaqData6",
      title: {
        rendered: str("service_rate_industry_faq_data_6_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_6_text_1",
        ]),
      },
    },
    {
      id: 7,
      renderId: "serviceRatePageFaqData7",
      title: {
        rendered: str("service_rate_industry_faq_data_7_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_7_text_1",
          "service_rate_industry_faq_data_7_text_2",
          "service_rate_industry_faq_data_7_text_3",
          "service_rate_industry_faq_data_7_text_4",
          "service_rate_industry_faq_data_7_text_5",
          "service_rate_industry_faq_data_7_text_6",
          "service_rate_industry_faq_data_7_text_7",
          "service_rate_industry_faq_data_7_text_8",
          "service_rate_industry_faq_data_7_text_9",
          "service_rate_industry_faq_data_7_text_10",
        ]),
      },
    },
    {
      id: 8,
      renderId: "serviceRatePageFaqData8",
      title: {
        rendered: str("service_rate_industry_faq_data_8_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_8_text_1",
        ]),
      },
    },
    {
      id: 9,
      renderId: "serviceRatePageFaqData9",
      title: {
        rendered: str("service_rate_industry_faq_data_9_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_9_text_1",
          "service_rate_industry_faq_data_9_text_2",
        ]),
      },
    },
    {
      id: 10,
      renderId: "serviceRatePageFaqData10",
      title: {
        rendered: str("service_rate_industry_faq_data_10_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_10_text_1",
        ]),
      },
    },
    {
      id: 11,
      renderId: "serviceRatePageFaqData11",
      title: {
        rendered: str("service_rate_industry_faq_data_11_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_industry_faq_data_11_text_1",
          "service_rate_industry_faq_data_11_text_2",
          "service_rate_industry_faq_data_11_text_3",
          "service_rate_industry_faq_data_11_text_4",
        ]),
      },
    }
  ];
  const serviceRatePageFaqData = [
    {
      id: 1,
      renderId: "serviceRatePageFaqData1",
      title: {
        rendered: str("service_rate_faq_data_1_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_1_text"]),
      },
    },
    {
      id: 2,
      renderId: "serviceRatePageFaqData2",
      title: {
        rendered: str("service_rate_faq_data_2_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_2_text"]),
      },
    },
    {
      id: 3,
      renderId: "serviceRatePageFaqData3",
      title: {
        rendered: str("service_rate_faq_data_3_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_faq_data_3_text_1",
          "service_rate_faq_data_3_text_2",
          "service_rate_faq_data_3_text_3",
          "service_rate_faq_data_3_text_4",
          "service_rate_faq_data_3_text_5",
          "service_rate_faq_data_3_text_6",
          "service_rate_faq_data_3_text_7",
          "service_rate_faq_data_3_text_8",
          "service_rate_faq_data_3_text_9",
          "service_rate_faq_data_3_text_10",
          "service_rate_faq_data_3_text_11",
          "service_rate_faq_data_3_text_12",
        ]),
      },
    },
    {
      id: 4,
      renderId: "serviceRatePageFaqData4",
      title: {
        rendered: str("service_rate_faq_data_4_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_4_text"]),
      },
    },
    {
      id: 5,
      renderId: "serviceRatePageFaqData5",
      title: {
        rendered: str("service_rate_faq_data_5_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_5_text"]),
      },
    },
    {
      id: 6,
      renderId: "serviceRatePageFaqData6",
      title: {
        rendered: str("service_rate_faq_data_6_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_6_text"]),
      },
    },
    {
      id: 7,
      renderId: "serviceRatePageFaqData7",
      title: {
        rendered: str("service_rate_faq_data_7_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_7_text"]),
      },
    },
    {
      id: 8,
      renderId: "serviceRatePageFaqData8",
      title: {
        rendered: str("service_rate_faq_data_8_title"),
      },
      content: {
        rendered: formatMessages([
          "service_rate_faq_data_8_text_1",
          "service_rate_faq_data_8_text_2",
          "service_rate_faq_data_8_text_3",
          "service_rate_faq_data_8_text_4",
          "service_rate_faq_data_8_text_5",
          "service_rate_faq_data_8_text_6",
          "service_rate_faq_data_8_text_7",
          "service_rate_faq_data_8_text_8",
          "service_rate_faq_data_8_text_9",
          "service_rate_faq_data_8_text_10",
        ]),
      },
    },
    {
      id: 9,
      renderId: "serviceRatePageFaqData9",
      title: {
        rendered: str("service_rate_faq_data_9_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_9_text"]),
      },
    },
    {
      id: 10,
      renderId: "serviceRatePageFaqData10",
      title: {
        rendered: str("service_rate_faq_data_10_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_10_text"]),
      },
    },
    {
      id: 11,
      renderId: "serviceRatePageFaqData11",
      title: {
        rendered: str("service_rate_faq_data_11_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_11_text"]),
      },
    },
    {
      id: 12,
      renderId: "serviceRatePageFaqData12",
      title: {
        rendered: str("service_rate_faq_data_12_title"),
      },
      content: {
        rendered: formatMessages(["service_rate_faq_data_12_text"]),
      },
    },
  ];


  const posDeviceData = [
    {
      id: 1,
      renderId: "posDeviceData1",
      title: str("pos_devices_clover_flex_title"),
      text: str("pos_devices_clover_flex_text"),
      img: CloverFlex,
      link: "/pos-device-clover-flex",
    },
    {
      id: 2,
      renderId: "posDeviceData2",
      title: str("pos_devices_clover_mini_title"),
      text: str("pos_devices_clover_mini_text"),
      img: CloverMini,
      link: "/pos-device-clover-mini",
    },
    {
      id: 3,
      renderId: "posDeviceData3",
      title: str("pos_devices_clover_station_duo_title"),
      text: str("pos_devices_clover_station_duo_text"),
      img: CloverStationDuo,
      link: "/pos-device-clover-station-duo",
    },
    {
      id: 4,
      renderId: "posDeviceData4",
      title: str("pos_devices_clover_station_solo_title"),
      text: str("pos_devices_clover_station_solo_text"),
      img: CloverStationSolo,
      link: "/pos-device-clover-station-solo",
    },
    {
      id: 5,
      renderId: "posDeviceData5",
      title: str("pos_devices_kitchen_display_system_title"),
      text: str("pos_devices_kitchen_display_system_text"),
      img: KitchenDisplaySystem,
      link: "/pos-device-kitchen-display-system",
    },
    {
      id: 6,
      renderId: "posDeviceData6",
      title: str("pos_devices_self_service_kiosk_title"),
      text: str("pos_devices_self_service_kiosk_text"),
      img: SelfServiceKiosk,
      link: "/pos-device-self-service-kiosk",
    },
  ];

  const browseByUseCasesData = [
    {
      id: 1,
      renderId: "useCaseData1",
      title: str("useCaseData1_title"),
      text: str("useCaseData1_text"),
      link: "/browse_by_use_case_data_i_accept_payments_at_the_counter",
    },
    {
      id: 2,
      renderId: "useCaseData2",
      title: str("useCaseData2_title"),
      text: str("useCaseData2_text"),
      link: "/browse_by_use_case_data_i_accept_payments_away_from_a_counter",
    },
    {
      id: 3,
      renderId: "useCaseData3",
      title: str("useCaseData3_title"),
      text: str("useCaseData3_text"),
      link: "/browse_by_use_case_data_i_accept_payments_on_the_road",
    },
    {
      id: 4,
      renderId: "useCaseData4",
      title: str("useCaseData4_title"),
      text: str("useCaseData4_text"),
      link: "/browse_by_use_case_data_i_invoice_my_customers",
    },
    {
      id: 5,
      renderId: "useCaseData5",
      title: str("useCaseData5_title"),
      text: str("useCaseData5_text"),
      link: "/browse_by_use_case_data_i_have_an_online_store",
    },
    {
      id: 6,
      renderId: "useCaseData6",
      title: str("useCaseData6_title"),
      text: str("useCaseData6_text"),
      link: "/browse_by_use_case_data_i_key_in_payments_on_behalf_of_my_customers",
    },
    {
      id: 7,
      renderId: "useCaseData7",
      title: str("useCaseData7_title"),
      text: str("useCaseData7_text"),
      link: "/browse_by_use_case_data_i_charge_a_fixed_recurring_fee",
    },
    {
      id: 8,
      renderId: "useCaseData8",
      title: str("useCaseData8_title"),
      text: str("useCaseData8_text"),
      link: "/browse_by_use_case_data_im_building_a_custom_website_or_software_application",
    },
    {
      id: 9,
      renderId: "useCaseData9",
      title: str("useCaseData9_title"),
      text: str("useCaseData9_text"),
      link: "/request-a-demo",
      hash: "contactUs"
    },
  ];
  
  const serviceRatesData = [
    {
      id: 1,
      renderId: "service_rate_title_1",
      title: str("service_rate_title_1"),
      link: "/service-rate/industry-0-10k"
    },
    {
      id: 2,
      renderId: "service_rate_title_2",
      title: str("service_rate_title_2"),
      link: "/service-rate/industry-10-50k"
    },
    {
      id: 3,
      renderId: "service_rate_title_3",
      title: str("service_rate_title_3"),
      link: "/service-rate/industry-50-100k"
    },
    {
      id: 4,
      renderId: "service_rate_title_4",
      title: str("service_rate_title_4"),
      link: "/service-rate/industry-100-250k"
    },
    {
      id: 5,
      renderId: "service_rate_title_5",
      title: str("service_rate_title_5"),
      link: "/service-rate/industry-250-500k"
    },
    {
      id: 6,
      renderId: "service_rate_title_6",
      title: str("service_rate_title_6"),
      link: "/service-rate/industry-500k"
    }
  ];

  function generateIndustryData(industryRange, industryNames) {
    return industryNames.map((industry, index) => ({
      id: index + 1,
      renderId: `select_your_industry${index + 1}_title`,
      title: str(`select_your_industry${index + 1}_title`),
      link: `/service-rate/${industryRange}/${industry}`,
    }));
  }

  const industryNames = [
    'auto_shop', 'cannabis', 'car_wash', 'charities', 'ecommerce', 'gas_station',
    'grocery', 'invoicing', 'medical', 'recurring_fees', 'restaurants', 'retail',
    'salons', 'services', 'taxi', 'variety_stores'
  ];
  const selectYourIndustry0To10KData = generateIndustryData('industry-0-10k', industryNames);
  const selectYourIndustry10To50KData = generateIndustryData('industry-10-50k', industryNames);
  const selectYourIndustry50To100KData = generateIndustryData('industry-50-100k', industryNames);
  const selectYourIndustry100To250KData = generateIndustryData('industry-100-250k', industryNames);
  const selectYourIndustry250To500KData = generateIndustryData('industry-250-500k', industryNames);
  const selectYourIndustry500KData = generateIndustryData('industry-500k', industryNames);



  const browseByUseCaseDataTitles = [
    {
      id: 1,
      renderId: "use_case_data_1_title",
      title: str("use_case_data_1_title"),
      text: formatMessages(["use_case_data_1_text_1", "use_case_data_1_text_2"]),
      class: "browse-by-use-case"
    },
    {
      id: 2,
      renderId: "use_case_data_2_title",
      title: str("use_case_data_2_title"),
      text: formatMessages(["use_case_data_2_text_1"]),
      class: "browse-by-use-case"
    },
    {
      id: 3,
      renderId: "use_case_data_3_title",
      title: str("use_case_data_3_title"),
      text: formatMessages(["use_case_data_3_text_1"]),
      class: "browse-by-use-case"
    },
    {
      id: 4,
      renderId: "use_case_data_4_title",
      title: str("use_case_data_4_title"),
      text: formatMessages(["use_case_data_4_text_1"]),
      class: "browse-by-use-case"
    },
    {
      id: 5,
      renderId: "use_case_data_5_title",
      title: str("use_case_data_5_title"),
      text: formatMessages(["use_case_data_5_text_1", "use_case_data_5_text_2", "use_case_data_5_text_3"]),
      class: "browse-by-use-case"
    },
    {
      id: 6,
      renderId: "use_case_data_6_title",
      title: str("use_case_data_6_title"),
      text: formatMessages(["use_case_data_6_text_1"]),
      class: "browse-by-use-case"
    },
    {
      id: 7,
      renderId: "use_case_data_7_title",
      title: str("use_case_data_7_title"),
      text: formatMessages(["use_case_data_7_text_1"]),
      class: "browse-by-use-case"
    },
    {
      id: 8,
      renderId: "use_case_data_8_title",
      title: str("use_case_data_8_title"),
      text: formatMessages(["use_case_data_8_text_1", "use_case_data_8_text_2"]),
      class: "browse-by-use-case"
    },
    {
      id: 9,
      renderId: "use_case_data_9_title",
      title: str("use_case_data_9_title"),
      text: formatMessages(["use_case_data_9_text_1"]),
      class: "browse-by-use-case"
    }
  ];
  const browseByUseCaseData_Taxi = [

    {
      title: str("use_case_data_clover_flex_title"),
      text: formatMessages([
        "use_case_data_clover_flex_text_1",
        "use_case_data_clover_flex_text_2",
        "use_case_data_clover_flex_text_3",
        "use_case_data_clover_flex_text_4",
        "use_case_data_clover_flex_text_5"
      ]),
      img: BrowseByUseCaseCloverMini

    }

  ];
  const browseByUseCaseData1 = [
    {
      title: str("use_case_data_clover_mini_title"),
      text: formatMessages([
        "use_case_data_clover_mini_text_1",
        "use_case_data_clover_mini_text_2",
        "use_case_data_clover_mini_text_3",
        "use_case_data_clover_mini_text_4",
        "use_case_data_clover_mini_text_5"
      ]),
      img: BrowseByUseCaseCloverMini

    },
    {
      title: str("use_case_data_clover_flex_title"),
      text: formatMessages([
        "use_case_data_clover_flex_text_1",
        "use_case_data_clover_flex_text_2",
        "use_case_data_clover_flex_text_3",
        "use_case_data_clover_flex_text_4",
        "use_case_data_clover_flex_text_5"
      ]),
      img: BrowseByUseCaseCloverFlex

    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers


    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // }
  ];
  // use case 2 and 3
  const browseByUseCaseData2and3 = [
    {
      title: str("use_case_data_clover_flex_title"),
      text: formatMessages([
        "use_case_data_clover_flex_text_1",
        "use_case_data_clover_flex_text_2",
        "use_case_data_clover_flex_text_3",
        "use_case_data_clover_flex_text_4",
        "use_case_data_clover_flex_text_5"
      ]),
      img: BrowseByUseCaseCloverFlex
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers
    // }
  ];

  const browseByUseCaseData4 = [
    {
      title: str("use_case_data_simple_checkout_title"),
      text: formatMessages([
        "use_case_data_simple_checkout_text_1"
      ]),
      img: BrowseByUseCaseSimpleCheckout
    },
    {
      title: str("use_case_data_invoicera_title"),
      text: formatMessages([
        "use_case_data_invoicera_text_1"
      ]),
      img: BrowseByUseCaseInvoicera
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers
    // }
  ];
  const browseByUseCaseData4_Industry = [
    {
      title: str("use_case_data_simple_checkout_title"),
      text: formatMessages([
        "use_case_data_simple_checkout_text_1"
      ]),
      img: BrowseByUseCaseSimpleCheckout
    },
    {
      title: str("use_case_data_invoicera_title"),
      text: formatMessages([
        "use_case_data_invoicera_text_1"
      ]),
      img: BrowseByUseCaseInvoicera
    },
    {
      title: str("use_case_data_clover_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_clover_virtual_terminal_text_1",
        "use_case_data_clover_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseCloverVirtualTerminal
    },
    {
      title: str("use_case_data_bambora_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_bambora_virtual_terminal_text_1",
        "use_case_data_bambora_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseBamboraVirtualTerminal
    },

  ];
  const browseByUseCaseData5 = [
    {
      title: str("use_case_data_woocommerce_title"),
      text: formatMessages([
        "use_case_data_woocommerce_text_1",
        "use_case_data_woocommerce_text_2"
      ]),
      img: BrowseByUseCaseWooCommerce
    },
    {
      title: str("use_case_data_ecwid_title"),
      text: formatMessages([
        "use_case_data_ecwid_text_1",
        "use_case_data_ecwid_text_2"
      ]),
      img: BrowseByUseCaseEcwid
    },
    {
      title: str("use_case_data_shopify_title"),
      text: formatMessages([
        "use_case_data_shopify_text_1",
        "use_case_data_shopify_text_2"
      ]),
      img: BrowseByUseCaseShopify
    },
    {
      title: str("use_case_data_magento_title"),
      text: formatMessages([
        "use_case_data_magento_text_1",
        "use_case_data_magento_text_2"
      ]),
      img: BrowseByUseCaseMagento
    },
    {
      title: str("use_case_data_opencart_title"),
      text: formatMessages([
        "use_case_data_opencart_text_1",
        "use_case_data_opencart_text_2"
      ]),
      img: BrowseByUseCaseOpenCart
    },
    {
      title: str("use_case_data_prestashop_title"),
      text: formatMessages([
        "use_case_data_prestashop_text_1",
        "use_case_data_prestashop_text_2"
      ]),
      img: BrowseByUseCasePrestaShop
    },
    {
      title: str("use_case_data_big_commerce_title"),
      text: formatMessages([
        "use_case_data_big_commerce_text_1",
        "use_case_data_big_commerce_text_2"
      ]),
      img: BrowseByUseCaseBigCommerce
    },
    {
      title: str("use_case_data_x_cart_title"),
      text: formatMessages([
        "use_case_data_x_cart_text_1",
        "use_case_data_x_cart_text_2"
      ]),
      img: BrowseByUseCaseXCcart
    },
    {
      title: str("use_case_data_volusion_title"),
      text: formatMessages([
        "use_case_data_volusion_text_1",
        "use_case_data_volusion_text_2"
      ]),
      img: BrowseByUseCaseVolusion
    },
    {
      title: str("use_case_data_miva_title"),
      text: formatMessages([
        "use_case_data_miva_text_1",
        "use_case_data_miva_text_2"
      ]),
      img: BrowseByUseCaseMivaEcommercePlatform
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers
    // }
  ];
  const browseByUseCaseData6 = [
    {
      title: str("use_case_data_clover_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_clover_virtual_terminal_text_1",
        "use_case_data_clover_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseCloverVirtualTerminal
    },
    {
      title: str("use_case_data_bambora_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_bambora_virtual_terminal_text_1",
        "use_case_data_bambora_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseBamboraVirtualTerminal
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers
    // }
  ];

  const browseByUseCaseData7 = [
    {
      title: str("use_case_data_clover_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_clover_virtual_terminal_text_1",
        "use_case_data_clover_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseCloverVirtualTerminal
    },
    {
      title: str("use_case_data_bambora_virtual_terminal_title"),
      text: formatMessages([
        "use_case_data_bambora_virtual_terminal_text_1",
        "use_case_data_bambora_virtual_terminal_text_2"
      ]),
      img: BrowseByUseCaseBamboraVirtualTerminal
    },
    {
      title: str("use_case_data_recurly_title"),
      text: formatMessages([
        "use_case_data_recurly_text_1"
      ]),
      img: BrowseByUseCaseRecurly
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // }
  ];

  const browseByUseCaseData8 = [
    {
      title: str("use_case_data_bambora_api_title"),
      text: formatMessages([
        "use_case_data_bambora_api_text_1",
        "use_case_data_bambora_api_text_2"
      ]),
      img: BrowseByUseCaseBamboraApi
    },
    {
      title: str("use_case_data_authorize_net_api_title"),
      text: formatMessages([
        "use_case_data_authorize_net_api_text_1",
        "use_case_data_authorize_net_api_text_2"
      ]),
      img: BrowseByUseCaseAuthorize
    },
    {
      title: str("use_case_data_chargify_title"),
      text: formatMessages([
        "use_case_data_chargify_text_1",
        "use_case_data_chargify_text_2"
      ]),
      img: BrowseByUseCaseChargify
    },
    // {
    //   title: str("use_case_data_quote_title"),
    //   text: formatMessages([
    //     "use_case_data_quote_text_1",
    //     "use_case_data_quote_text_2"
    //   ]),
    //   img: BrowseByUseCaseQuote
    // },
    // {
    //   title: str("use_case_data_customers_title"),
    //   text: formatMessages([
    //     "use_case_data_customers_text_1",
    //     "use_case_data_customers_text_2"
    //   ]),
    //   img: BrowseByUseCaseCustomers
    // }
  ];

  const browseByUseCaseData9 = [
    {
      title: str("use_case_data_contact_title"),
      text: formatMessages([
        "use_case_data_contact_text_1",
        "use_case_data_contact_text_2"
      ]),
      img: ""
    },
    {
      title: str("use_case_data_quote_title"),
      text: formatMessages([
        "use_case_data_quote_text_1",
        "use_case_data_quote_text_2"
      ]),
      img: BrowseByUseCaseQuote
    }
  ];

  const softwareSolution = [
    {
      id: 1,
      renderId: "softwareSolution1",
      title: str("software_data_title1"),
      text: [str("software_data_desc1"), str("software_data_desc1_2")],
      link: "/acquire-new-customers",
      img: Software,
      benefit: [
        {
          id: 1,
          text: str("software_data_bene1"),
        },
        {
          id: 2,
          text: str("software_data_bene1_2"),
        },
        {
          id: 3,
          text: str("software_data_bene1_3"),
        },
      ],
    },
    {
      id: 2,
      renderId: "softwareSolution2",
      title: str("software_data_title2"),
      text: [str("software_data_desc2"), str("software_data_desc2_2")],
      link: "/own-your-online-brand",
      class: "own-brand",
      img: OnlineBland,
      benefit: [
        {
          id: 1,
          text: str("software_data_bene2"),
        },
        {
          id: 2,
          text: str("software_data_bene2_2"),
        },
        {
          id: 3,
          text: str("software_data_bene2_3"),
        },
      ],
    },
    {
      id: 3,
      renderId: "softwareSolution3",
      title: "Automate Your Ordering Process",
      text: [str("software_data_desc3"), str("software_data_desc3_2")],
      link: "/automate-order-process",
      img: Automate,
      benefit: [
        {
          id: 1,
          text: str("software_data_bene3"),
        },
        {
          id: 2,
          text: str("software_data_bene3_2"),
        },
        {
          id: 3,
          text: str("software_data_bene3_3"),
        },
      ],
    },
  ];

  const cloverFlexData = {
    banner_left_title: str("clover_flex_banner_left_title"),
    banner_right_contents: [
      str("clover_flex_banner_right_contents1"),
      str("clover_flex_banner_right_contents2"),
      str("clover_flex_banner_right_contents3"),
    ],
    features: [
      {
        title: str("clover_flex_features1_title"),
        text: str("clover_flex_features1_text"),
        img: CloverFlex0,
      },
      {
        title: str("clover_flex_features2_title"),
        text: str("clover_flex_features2_text"),
        img: CloverFlex1,
      },
      {
        title: str("clover_flex_features3_title"),
        text: str("clover_flex_features3_text"),
        img: CloverFlex2,
      },
      {
        title: str("clover_flex_features4_title"),
        text: str("clover_flex_features4_text"),
        img: CloverFlex3,
      },

      {
        title: str("clover_flex_features6_title"),
        text: str("clover_flex_features6_text"),
        img: CloverFlex4,
      },
      {
        title: str("clover_flex_features7_title"),
        text: str("clover_flex_features7_text"),
        img: CloverFlex5,
      },
      {
        title: str("clover_flex_features8_title"),
        text: str("clover_flex_features8_text"),
        img: CloverFlex6,
      },
      {
        title: str("clover_flex_features9_title"),
        text: str("clover_flex_features9_text"),
        img: CloverFlex7,
      },
      {
        title: str("clover_flex_features5_title"),
        text: str("clover_flex_features5_text"),
        img: CloverFlex8,
      },

    ],
  };
  const cloverMiniData = {
    banner_left_title: str("clover_mini_banner_left_title"),
    banner_right_contents: [
      str("clover_mini_banner_right_contents1"),
    ],
    features: [
      {
        title: str("clover_mini_features1_title"),
        text: str("clover_mini_features1_text"),
        img: CloverMini0,
      },
      {
        title: str("clover_mini_features12_title"),
        text: str("clover_mini_features12_text"),
        img: CloverMini6,
      },
      {
        title: str("clover_mini_features2_title"),
        text: str("clover_mini_features2_text"),
        img: CloverMini7,
      },
      {
        title: str("clover_mini_features3_title"),
        text: str("clover_mini_features3_text"),
        img: CloverMini8,
      },
      {
        title: str("clover_mini_features4_title"),
        text: str("clover_mini_features4_text"),
        img: CloverMini9,
      },
      {
        title: str("clover_mini_features5_title"),
        text: str("clover_mini_features5_text"),
        img: CloverMini1,
      },
      {
        title: str("clover_mini_features6_title"),
        text: str("clover_mini_features6_text"),
        img: CloverMini10,
      },
      {
        title: str("clover_mini_features7_title"),
        text: str("clover_mini_features7_text"),
        img: CloverMini11,
      },
      {
        title: str("clover_mini_features8_title"),
        text: str("clover_mini_features8_text"),
        img: CloverMini2,
      },
      {
        title: str("clover_mini_features9_title"),
        text: str("clover_mini_features9_text"),
        img: CloverMini3,
      },
      {
        title: str("clover_mini_features10_title"),
        text: str("clover_mini_features10_text"),
        img: CloverMini4,
      },
      {
        title: str("clover_mini_features11_title"),
        text: str("clover_mini_features11_text"),
        img: CloverMini5,
      },



    ],
  };
  const cloverStationDuoDataFeature5 =
    [
      "clover_station_duo_features5_text1",
      "clover_station_duo_features5_text2",
    ]

  const cloverStationDuoDataFeature6 =
    ["clover_station_duo_features6_text1",
      "clover_station_duo_features6_text2",
      "clover_station_duo_features6_text3"]

  const cloverStationDuoData = {
    banner_left_title: str("clover_station_duo_banner_left_title"),
    banner_right_contents: [
      str("clover_station_duo_banner_right_contents1"),
    ],
    features: [
      {
        title: str("clover_station_duo_features1_title"),
        text: str("clover_station_duo_features1_text"),
        img: CloverStationDuo0,
      },
      {
        title: str("clover_station_duo_features2_title"),
        text: str("clover_station_duo_features2_text"),
        img: CloverStationDuo3,
      },
      {
        title: str("clover_station_duo_features3_title"),
        text: str("clover_station_duo_features3_text"),
        img: CloverStationDuo4,
      },
      {
        title: str("clover_station_duo_features4_title"),
        text: str("clover_station_duo_features4_text"),
        img: CloverStationDuo5,
      },
      {
        title: str("clover_station_duo_features5_title"),
        text: formatMessages(cloverStationDuoDataFeature5),
        img: CloverStationDuo1,
      },

      {
        title: str("clover_station_duo_features7_title"),
        text: str("clover_station_duo_features7_text"),
        img: CloverStationDuo6,
      },
      {
        title: str("clover_station_duo_features8_title"),
        text: str("clover_station_duo_features8_text"),
        img: CloverStationDuo7,
      },
      {
        title: str("clover_station_duo_features9_title"),
        text: str("clover_station_duo_features9_text"),
        img: CloverStationDuo8,
      },
      {
        title: str("clover_station_duo_features10_title"),
        text: str("clover_station_duo_features10_text"),
        img: CloverStationDuo9,
      },

      {
        title: str("clover_station_duo_features6_title"),
        text: formatMessages(cloverStationDuoDataFeature6),
        img: CloverStationDuo2,
      },

    ],
  };
  const cloverStationSoloData = {
    banner_left_title: str("clover_station_solo_banner_left_title"),
    banner_right_contents: [
      str("clover_station_solo_banner_right_contents1"),
    ],
    features: [
      {
        title: str("clover_station_solo_features1_title"),
        text: str("clover_station_solo_features1_text"),
        img: CloverStationSolo2,
      },
      {
        title: str("clover_station_solo_features2_title"),
        text: str("clover_station_solo_features2_text"),
        img: CloverStationSolo5,
      },
      {
        title: str("clover_station_solo_features3_title"),
        text: str("clover_station_solo_features3_text"),
        img: CloverStationSolo6,
      },
      {
        title: str("clover_station_solo_features4_title"),
        text: str("clover_station_solo_features4_text"),
        img: CloverStationSolo7,
      },
      {
        title: str("clover_station_solo_features5_title"),
        text: str("clover_station_solo_features5_text"),
        img: CloverStationSolo1,
      },
      {
        title: str("clover_station_solo_features6_title"),
        text: str("clover_station_solo_features6_text"),
        img: CloverStationSolo3,
      },
      {
        title: str("clover_station_solo_features7_title"),
        text: str("clover_station_solo_features7_text"),
        img: CloverStationSolo4,
      },
      {
        title: str("clover_station_solo_features8_title"),
        text: str("clover_station_solo_features8_text"),
        img: CloverStationSolo0,
      },
    ],
  };

  const kitchenSubData1 =
    ["kitchen_display_system_features1_text_1",
      "kitchen_display_system_features1_text_2",
      "kitchen_display_system_features1_text_3"]
  const kitchenSubData2 =
    ["kitchen_display_system_features2_text_1",
      "kitchen_display_system_features2_text_2",
      "kitchen_display_system_features2_text_3",
      "kitchen_display_system_features2_text_4",
      "kitchen_display_system_features2_text_5"]
  const kitchenSubData3 =
    ["kitchen_display_system_features3_text_1",
      "kitchen_display_system_features3_text_2",
      "kitchen_display_system_features3_text_3"]
  const kitchenSubData4 = [
    "kitchen_display_system_features4_text_1",
    "kitchen_display_system_features4_text_2",
    "kitchen_display_system_features4_text_3",
    "kitchen_display_system_features4_text_4",
    "kitchen_display_system_features4_text_5"
  ];
  const kitchenSubData5 = [
    "kitchen_display_system_features5_text_1",
    "kitchen_display_system_features5_text_2",
    "kitchen_display_system_features5_text_3",
  ];


  const kitchenDisplaySystemData = {
    banner_left_title: str("kitchen_display_system_banner_left_title"),
    banner_right_contents: [
      str("kitchen_display_system_banner_right_contents1"),
    ],
    features: [
      {
        title: str("kitchen_display_system_features1_title"),
        text: formatMessages(kitchenSubData1),
        img: KitchenDisplaySystem3,
      },
      {
        title: str("kitchen_display_system_features2_title"),
        text: formatMessages(kitchenSubData2),
        img: KitchenDisplaySystem0,
      },
      {
        title: str("kitchen_display_system_features3_title"),
        text: formatMessages(kitchenSubData3),
        img: KitchenDisplaySystem4,
      },
      {
        title: str("kitchen_display_system_features4_title"),
        text: formatMessages(kitchenSubData4),
        img: KitchenDisplaySystem1,
      },
      {
        title: str("kitchen_display_system_features5_title"),
        text: formatMessages(kitchenSubData5),
        img: KitchenDisplaySystem2,
      },
    ],
  };

  const selfServiceKioskData2 = [
    "self_service_kiosk_features2_text1",
    "self_service_kiosk_features2_text2",
    "self_service_kiosk_features2_text3",
    "self_service_kiosk_features2_text4",
    "self_service_kiosk_features2_text5"
  ];


  const selfServiceKioskData4 = [
    "self_service_kiosk_features4_text1",
    "self_service_kiosk_features4_text2",
    "self_service_kiosk_features4_text3",
    "self_service_kiosk_features4_text4"
  ];

  const selfServiceKioskData5 = [
    // "self_service_kiosk_features5_text1",
    "self_service_kiosk_features5_text2",
    "self_service_kiosk_features5_text3",
    // "self_service_kiosk_features5_text4",
    "self_service_kiosk_features5_text5",
    "self_service_kiosk_features5_text6",
    "self_service_kiosk_features5_text7",
    // "self_service_kiosk_features5_text8",
    "self_service_kiosk_features5_text9",
    "self_service_kiosk_features5_text10"
  ];

  const selfServiceKioskData6 = [
    // "self_service_kiosk_features6_text1",
    "self_service_kiosk_features6_text2",
    "self_service_kiosk_features6_text3",
    "self_service_kiosk_features6_text4",
    "self_service_kiosk_features6_text5",
    "self_service_kiosk_features6_text6"
  ];

  const selfServiceKioskData7 = [
    // "self_service_kiosk_features7_text1",
    "self_service_kiosk_features7_text2"
  ];

  const selfServiceKioskData8 = [
    "self_service_kiosk_features8_text1",
    "self_service_kiosk_features8_text2",
    "self_service_kiosk_features8_text5",
    "self_service_kiosk_features8_text8",
    "self_service_kiosk_features8_text9",
    "self_service_kiosk_features8_text10",
    "self_service_kiosk_features8_text11",
    "self_service_kiosk_features8_text12",
    "self_service_kiosk_features8_text13"
  ];

  const selfServiceKioskData9 = [
    "self_service_kiosk_features9_text1",
    "self_service_kiosk_features9_text2",
    "self_service_kiosk_features9_text3",
    "self_service_kiosk_features9_text4"
  ];

  const selfServiceKioskData11 = [
    "self_service_kiosk_features11_text1",
    "self_service_kiosk_features11_text2",
    "self_service_kiosk_features11_text3",
    "self_service_kiosk_features11_text4"
  ];

  const selfServiceKioskData12 = [
    "self_service_kiosk_features1_text1",
    "self_service_kiosk_features1_text2", 
    "self_service_kiosk_features1_text3", 
    "self_service_kiosk_features1_text4", 
    "self_service_kiosk_features1_text5", 
    "self_service_kiosk_features1_text6"
  ]

  const selfServiceKioskData13 = [
    "self_service_kiosk_features13_text1",
    "self_service_kiosk_features13_text2", 
    "self_service_kiosk_features13_text3", 
    "self_service_kiosk_features13_text4", 
    "self_service_kiosk_features13_text5", 
    "self_service_kiosk_features13_text6"
  ]

  const selfServiceKioskData14 = [
    "self_service_kiosk_features14_text1",
    "self_service_kiosk_features14_text2", 
    "self_service_kiosk_features14_text3", 
    "self_service_kiosk_features14_text4",
  ]

  const selfServiceKioskData = {
    banner_left_title: str("self_service_kiosk_banner_left_title"),
    banner_right_contents: [
      str("self_service_kiosk_banner_right_contents1"),
    ],
    features: [
      // {
      //   title: str("self_service_kiosk_features1_title"),
      //   text: str("self_service_kiosk_features1_text1"),
      //   img: SelfServiceKiosk4,
      // },
      {
        title: str("self_service_kiosk_features1_title"),
        text: formatMessages(selfServiceKioskData12),
        img: SelfServiceKiosk12,
      },
      {
        title: str("self_service_kiosk_features13_title"),
        text: formatMessages(selfServiceKioskData13),
        img: SelfServiceKiosk13,
      },
      {
        title: str("self_service_kiosk_features14_title"),
        text: formatMessages(selfServiceKioskData14),
        img: SelfServiceKiosk14,
      },
      {
        title: str("self_service_kiosk_features7_title"),
        text: formatMessages(selfServiceKioskData7),
        img: SelfServiceKiosk7,
      },
      {
        title: str("self_service_kiosk_features6_title"),
        text: formatMessages(selfServiceKioskData6),
        img: SelfServiceKiosk6,
      },
      {
        title: str("self_service_kiosk_features2_title"),
        text: formatMessages(selfServiceKioskData2),
        img: SelfServiceKiosk0,
      },

      {
        title: str("self_service_kiosk_features4_title"),
        text: formatMessages(selfServiceKioskData4),
        img: SelfServiceKiosk1,
      },
      {
        title: str("self_service_kiosk_features5_title"),
        text: formatMessages(selfServiceKioskData5),
        img: SelfServiceKiosk2,
      },
      // {
      //   title: str("self_service_kiosk_features6_title"),
      //   text: formatMessages(selfServiceKioskData6),
      //   img: SelfServiceKiosk6,
      // },

      {
        title: str("self_service_kiosk_features8_title"),
        text: formatMessages(selfServiceKioskData8),
        img: SelfServiceKiosk8,
      },
      // {
      //   title: str("self_service_kiosk_features9_title"),
      //   text: formatMessages(selfServiceKioskData9),
      //   img: SelfServiceKiosk3,
      // },
      {
        title: str("self_service_kiosk_features11_title"),
        text: formatMessages(selfServiceKioskData11),
        img: SelfServiceKiosk5,
      },
    ],
  };




  const acquireCustomerData = {
    banner_left_title: str("acquire_customer_banner_left_title"),
    banner_right_contents: [
      str("acquire_customer_banner_right_contents1"),
      str("acquire_customer_banner_right_contents2"),
    ],
    features: [
      {
        title: str("acquire_customer_features1_title"),
        text: str("acquire_customer_features1_text"),
        img: EcommerceSocialShare,
      },
      {
        title: str("acquire_customer_features2_title"),
        text: str("acquire_customer_features2_text"),
        icon_contents: {
          title: str("acquire_customer_features2_language_support"),
          text: str("acquire_customer_features2_language"),
          icon: LangSvgRepo,
        },
        img: EcommerceMultiLang,
      },
      {
        title: str("acquire_customer_features3_title"),
        text: str("acquire_customer_features3_text"),
        img: SeoEcommerce,
      },
    ],
  };

  const onlineBrandData = {
    banner_left_title: str("online_brand_banner_left_title"),
    banner_right_contents: [
      str("online_brand_banner_right_contents1"),
      str("online_brand_banner_right_contents2"),
    ],
    features: [
      {
        title: str("online_brand_features1_title"),
        text: str("online_brand_features1_text"),
        high_light_text: [
          "Custom Domain",
          "Display business info",
          "Multiple Menus",
        ],
        img: EcommerceOnlineOrdering,
      },
      {
        title: str("online_brand_features2_title"),
        text: str("online_brand_features2_text"),

        img: CustomerDatabase,
      },
      {
        title: str("online_brand_features3_title"),
        text: str("online_brand_features3_text"),
        img: CustomerReview,
      },
      {
        title: str("online_brand_features4_title"),
        text: str("online_brand_features4_text"),
        img: LoyaltyGiftCard,
      },
      {
        title: str("online_brand_features5_title"),
        text: str("online_brand_features5_text"),
        img: GuidanceResources,
      },
    ],
  };
  const autoOrderData = {
    banner_left_title: str("auto_order_banner_left_title"),
    banner_right_contents: [
      str("auto_order_banner_right_contents1"),
      str("auto_order_banner_right_contents2"),
    ],
    features: [
      {
        title: str("auto_order_features1_title"),
        text: str("auto_order_features1_text"),
        img: EcommerceSelfOrdering,
      },
      {
        title: str("auto_order_features3_title"),
        text: str("auto_order_features3_text"),
        img: EcommercePayments,
      },
      {
        title: str("auto_order_features4_title"),
        text: str("auto_order_features4_text"),
        img: EcommerceAutoPrint,
      },
      {
        title: str("auto_order_features5_title"),
        text: str("auto_order_features5_text"),
        img: EcommercePremise,
      },
      {
        title: str("auto_order_features6_title"),
        text: str("auto_order_features6_text"),
        img: StaffPosOrdering,
      },
      {
        title: str("auto_order_features7_title"),
        text: str("auto_order_features7_text"),
        img: EcommercePayTransfer,
      },
    ],
  };

  const about = {
    header: {
      subtitle: str("about_sbtitle"),
      title: str("about_title"),
      text: str("about_text"),
    },
    contents: [
      {
        title: str("about_contents_title1"),
        text: [str("about_contents_text1"), str("about_contents_text1_2")],
        svg: Mission,
      },
      {
        title: str("about_contents_title2"),
        text: [str("about_contents_text2")],
        svg: Logo,
        className: "logo",
        img_className: "goopter-logo",
      },
    ],
  };
  const features = {
    header: {
      title: str("features_header_title"),
      text: str("features_header_text"),
    },
    business: [
      {
        title: str("features_business_title"),
        iconUrl: FeatureWebsite,
        contents: [
          {
            title: str("features_business_contents_title"),
            text: str("features_business_contents_text"),
          },
          {
            title: str("features_business_contents_title2"),
            text: str("features_business_contents_text2"),
          },
          {
            title: str("features_business_contents_title3"),
            text: str("features_business_contents_text3"),
          },
          {
            title: str("features_business_contents_title4"),
            text: str("features_business_contents_text4"),
          },
          {
            title: str("features_business_contents_title5"),
            text: str("features_business_contents_text5"),
          },
          {
            title: str("features_business_contents_title6"),
            text: str("features_business_contents_text6"),
          },
          {
            title: str("features_business_contents_title7"),
            text: str("features_business_contents_text7"),
          },
          {
            title: str("features_business_contents_title8"),
            text: str("features_business_contents_text8"),
          },
        ],
      },
      {
        title: str("features_business_customer_title"),
        iconUrl: Customer,
        contents: [
          {
            title: str("features_business_customer_contents_title"),
            text: str("features_business_customer_contents_text"),
          },
          {
            title: str("features_business_customer_contents_title2"),
            text: str("features_business_customer_contents_text2"),
          },
          {
            title: str("features_business_customer_contents_title3"),
            text: str("features_business_customer_contents_text3"),
          },
          {
            title: str("features_business_customer_contents_title4"),
            text: str("features_business_customer_contents_text4"),
          },
          {
            title: str("features_business_customer_contents_title5"),
            text: str("features_business_customer_contents_text5"),
          },
          {
            title: str("features_business_customer_contents_title6"),
            text: str("features_business_customer_contents_text6"),
            coming: true,
          },
        ],
      },
      {
        title: str("features_business_management_title"),
        iconUrl: Management,
        contents: [
          {
            title: str("features_business_management_contents_title"),
            text: str("features_business_management_contents_text"),
          },
          {
            title: str("features_business_management_contents_title2"),
            text: str("features_business_management_contents_text2"),
          },
          {
            title: str("features_business_management_contents_title3"),
            text: str("features_business_management_contents_text3"),
          },
          {
            title: str("features_business_management_contents_title4"),
            text: str("features_business_management_contents_text4"),
          },
          {
            title: str("features_business_management_contents_title5"),
            text: str("features_business_management_contents_text5"),
          },
          {
            title: str("features_business_management_contents_title6"),
            text: str("features_business_management_contents_text6"),
          },
          {
            title: str("features_business_management_contents_title7"),
            text: str("features_business_management_contents_text7"),
          },
          {
            title: str("features_business_management_contents_title8"),
            text: str("features_business_management_contents_text8"),
          },
          {
            title: str("features_business_management_contents_title9"),
            text: str("features_business_management_contents_text9"),
          },
          {
            title: str("features_business_management_contents_title10"),
            text: str("features_business_management_contents_text10"),
          },
          {
            title: str("features_business_management_contents_title11"),
            text: str("features_business_management_contents_text11"),
          },
          {
            title: str("features_business_management_contents_title12"),
            text: str("features_business_management_contents_text12"),
          },
          {
            title: str("features_business_management_contents_title13"),
            text: str("features_business_management_contents_text13"),
          },
          {
            title: str("features_business_management_contents_title14"),
            text: str("features_business_management_contents_text14"),
          },
          {
            title: str("features_business_management_contents_title15"),
            text: str("features_business_management_contents_text15"),
          },
          {
            title: str("features_business_management_contents_title16"),
            text: str("features_business_management_contents_text16"),
          },
          {
            title: str("features_business_management_contents_title17"),
            text: str("features_business_management_contents_text17"),
          },
          {
            title: str("features_business_management_contents_title18"),
            text: str("features_business_management_contents_text18"),
          },
          {
            title: str("features_business_management_contents_title19"),
            text: str("features_business_management_contents_text19"),
          },
          {
            title: str("features_business_management_contents_title20"),
            text: str("features_business_management_contents_text20"),
          },
        ],
      },
    ],
    consumer: [
      {
        title: str("features_consumer_ordering_title"),
        iconUrl: Smartphone,
        contents: [
          {
            title: str("features_consumer_ordering_contents_title"),
            text: str("features_consumer_ordering_contents_text"),
          },
          {
            title: str("features_consumer_ordering_contents_title2"),
            text: str("features_consumer_ordering_contents_text2"),
          },
          {
            title: str("features_consumer_ordering_contents_title3"),
            text: str("features_consumer_ordering_contents_text3"),
          },
          {
            title: str("features_consumer_ordering_contents_title4"),
            text: str("features_consumer_ordering_contents_text4"),
          },
          {
            title: str("features_consumer_ordering_contents_title5"),
            text: str("features_consumer_ordering_contents_text5"),
          },
          {
            title: str("features_consumer_ordering_contents_title6"),
            text: str("features_consumer_ordering_contents_text6"),
          },
          {
            title: str("features_consumer_ordering_contents_title7"),
            text: str("features_consumer_ordering_contents_text7"),
          },
          {
            title: str("features_consumer_ordering_contents_title8"),
            text: str("features_consumer_ordering_contents_text8"),
          },
          {
            title: str("features_consumer_ordering_contents_title9"),
            text: str("features_consumer_ordering_contents_text9"),
          },
          {
            title: str("features_consumer_ordering_contents_title10"),
            text: str("features_consumer_ordering_contents_text10"),
          },
          {
            title: str("features_consumer_ordering_contents_title11"),
            text: str("features_consumer_ordering_contents_text11"),
          },
          {
            title: str("features_consumer_ordering_contents_title12"),
            text: str("features_consumer_ordering_contents_text12"),
          },
          {
            title: str("features_consumer_ordering_contents_title13"),
            text: str("features_consumer_ordering_contents_text13"),
          },
          {
            title: str("features_consumer_ordering_contents_title14"),
            text: str("features_consumer_ordering_contents_text14"),
          },
          {
            title: str("features_consumer_ordering_contents_title15"),
            text: str("features_consumer_ordering_contents_text15"),
          },
          {
            title: str("features_consumer_ordering_contents_title16"),
            text: str("features_consumer_ordering_contents_text16"),
          },
          {
            title: str("features_consumer_ordering_contents_title17"),
            text: str("features_consumer_ordering_contents_text17"),
          },
          {
            title: str("features_consumer_ordering_contents_title18"),
            text: str("features_consumer_ordering_contents_text18"),
          },
          {
            title: str("features_consumer_ordering_contents_title19"),
            text: str("features_consumer_ordering_contents_text19"),
          },
          {
            title: str("features_consumer_ordering_contents_title20"),
            text: str("features_consumer_ordering_contents_text20"),
          },
        ],
      },
      {
        title: str("features_consumer_promo_title"),
        iconUrl: Discount,
        contents: [
          {
            title: str("features_consumer_promo_contents_title"),
            text: str("features_consumer_promo_contents_text"),
          },
          {
            title: str("features_consumer_promo_contents_title2"),
            text: str("features_consumer_promo_contents_text2"),
          },
        ],
      },
      {
        title: str("features_consumer_account_title"),
        iconUrl: Account,
        contents: [
          {
            title: str("features_consumer_account_contents_title"),
            text: str("features_consumer_account_contents_text"),
          },
          {
            title: str("features_consumer_account_contents_title2"),
            text: str("features_consumer_account_contents_text2"),
          },
          {
            title: str("features_consumer_account_contents_title3"),
            text: str("features_consumer_account_contents_text3"),
          },
          {
            title: str("features_consumer_account_contents_title4"),
            text: str("features_consumer_account_contents_text4"),
          },
          {
            title: str("features_consumer_account_contents_title5"),
            text: str("features_consumer_account_contents_text5"),
          },
          {
            title: str("features_consumer_account_contents_title6"),
            text: str("features_consumer_account_contents_text6"),
          },
        ],
      },
    ],
  };
  const pricingData = {
    header: {
      title: str("pricing_header_title"),
      text: str("pricing_header_text"),
      btn_text: str("request_a_demo"),
    },
    options: {
      title: str("pricing_options_title"),
      sub_title: str("pricing_options_sub_title"),
      non_obligation: [
        {
          id: "non_obligation1",
          title: str("pricing_options_non_obli_title"),
          sub_title: str("pricing_options_non_obli_subtitle"),
          list: [
            str("pricing_options_non_obli_list1"),
            str("pricing_options_non_obli_list1_2"),
            str("pricing_options_non_obli_list1_3"),
          ],
          btn_color: "primary",
          btn_text: str("sign_up"),
          btn_link: "/signup",
        },
        {
          id: "non_obligation2",
          title: str("pricing_options_non_obli_title2"),
          sub_title: str("pricing_options_non_obli_subtitle2"),
          list: [
            str("pricing_options_non_obli_list2_1"),
            str("pricing_options_non_obli_list2_2"),
          ],
          btn_color: "primary",
          btn_text: str("sign_up"),
          btn_link: "/signup",
        },
        {
          id: "non_obligation3",
          title: str("pricing_options_non_obli_title3"),
          sub_title: str("pricing_options_non_obli_subtitle3"),
          list: [str("pricing_options_non_obli_list3_1")],
          btn_color: "accent",
          btn_text: str("request_a_quote"),
          btn_link: "/request-a-demo",
        },
      ],
      monthly_title: str("pricing_options_monthly_title"),
      monthly: [
        {
          id: "monthly1",
          title: str("pricing_options_monthly_title"),
          sub_title: str("pricing_options_monthly_card_title"),
          list: [
            str("pricing_options_monthly_card_list1"),
            str("pricing_options_monthly_card_list1_2"),
          ],
          btn_color: "accent",
          btn_text: str("request_a_demo"),
          btn_link: "/request-a-demo",
        },
      ],
      including_fetures_title: str("pricing_including_fetures_title"),
      including_fetures_small_text: str("pricing_including_fetures_small_text"),
      including_features: [
        {
          id: "including_features1",
          img: including1,
          text: str("pricing_including_fetures_text1"),
        },
        {
          id: "including_features2",
          img: including2,
          text: str("pricing_including_fetures_text2"),
        },
        {
          id: "including_features3",
          img: including3,
          text: str("pricing_including_fetures_text3"),
        },
        {
          id: "including_features4",
          img: including4,
          text: str("pricing_including_fetures_text4"),
        },
        {
          id: "including_features5",
          img: including5,
          text: str("pricing_including_fetures_text5"),
        },
        {
          id: "including_features6",
          img: including6,
          text: str("pricing_including_fetures_text6"),
        },
        {
          id: "including_features7",
          img: including7,
          text: str("pricing_including_fetures_text7"),
        },
        {
          id: "including_features8",
          img: including8,
          text: str("pricing_including_fetures_text8"),
        },
        {
          id: "including_features9",
          img: including9,
          text: str("pricing_including_fetures_text9"),
        },
        {
          id: "including_features10",
          img: including10,
          text: str("pricing_including_fetures_text10"),
        },
        {
          id: "including_features11",
          img: including11,
          text: str("pricing_including_fetures_text11"),
        },
        {
          id: "including_features12",
          img: including12,
          text: str("pricing_including_fetures_text12"),
        },
      ],
    },
  };
  const blogListData = {
    header: {
      title: str("blog_list_header_title"),
      text: str("blog_list_header_text"),
    },
  };
  const contactData = {
    header: {
      title: str("contact_us"),
      subtitle: str("contact_header_subtitle"),
      text: str("contact_header_text"),
    },
    form: {
      name: str("name"),
      email: str("email"),
      subject: str("subject"),
      message: str("write_a_message"),
      submit: str("submit"),
      title: str("send_message"),
    },
    head_office: {
      title: str("head_office"),
      offices: [
        {
          name: str("head_office"),
          phone: "(778) 379-7918",
          email: "info@goopter.com",
          address: [
            "104 - 7777 Royal Oak Avenue",
            "Burnaby, BC V5J 4K2",
            "Canada",
          ],
        },
      ],
    },
    other_offices: {
      title: str("our_other_offices"),
      offices: [
        {
          name: str("usa_texas_office"),
          phone: "(281) 965-5373",
          email: "info-tx@goopter.com",
          address: ["9219 Bellaire Blvd. #153", "Houston, TX 77036", "USA"],
        },
        {
          name: str("usa_cali_office"),
          phone: "(510) 512-6789",
          email: "info-ca@goopter.com",
          address: ["25 Crescent Dr. #A232", "Pleasant Hill, CA 94523", "USA"],
        },
      ],
    },
    follow_us: str("follow_us"),
  };
  const requestADemoData = {
    form: {
      title: str("lets_chat"),
      first_name: str("first_name"),
      last_name: str("last_name"),
      name: str("last_name"),
      email: str("email"),
      phone: str("phone"),
      subject: str("subject"),
      message: str("write_a_message"),
      submit: str("submit"),
      company_or_business: str("company_or_business"),
      store_address: str("store_address"),
      im_interested_in: str("im_interested_in"),
      country: str("country"),
      additional_comments: str("additional_comments"),
      restaurant: str("restaurant"),
      retail_store: str("retail_store"),
      online_ordering_solution: str("online_ordering_solution"),
      delivery_robots: str("delivery_robots"),
      merchant_service: str("merchant_service"),
      merchant_service_introduction: str("merchant_service_introduction"),
      restaurant_automation: str("restaurant_automation"),
      photography_service: str("photography_service"),
      signup: str("sign_up"),
      canada: str("canada"),
      not_canada: str("not_canada"),
      other: str("other"),
      commercial_equipment_leasing: str("commercial_equipment_leasing"),
    },
  };
  const signUpData = {
    header: {
      title: str("signup_header_title"),
      text: str("signup_header_text"),
    },
    form: {
      title: str("get_started"),
      first_name: str("first_name"),
      last_name: str("last_name"),
      name: str("last_name"),
      email: str("email"),
      phone: str("phone"),
      subject: str("subject"),
      message: str("write_a_message"),
      submit: str("submit"),
      company_or_business: str("company_or_business"),
      store_address: str("store_address"),
      im_interested_in: str("im_interested_in"),
      country: str("country"),
      additional_comments: str("additional_comments"),
      restaurant: str("restaurant"),
      retail_store: str("retail_store"),
      online_ordering_solution: str("online_ordering_solution"),
      delivery_robots: str("delivery_robots"),
      restaurant_automation: str("restaurant_automation"),
      photography_service: str("photography_service"),
      signup: str("sign_up"),
      canada: str("canada"),
      not_canada: str("not_canada"),
      other: str("other"),
      merchant_service: str("merchant_service"),
      merchant_service_introduction: str("merchant_service_introduction"),
    },
    contents: {
      why_goopter: {
        title: str("signup_why_goopter_title"),
        contents: [
          { icon: Search, text: str("signup_why_goopter_contents_text1") },
          { icon: Website, text: str("signup_why_goopter_contents_text2") },
          { icon: MultiDivice, text: str("signup_why_goopter_contents_text3") },
        ],
      },
      how_to: {
        title: str("signup_how_to_title"),
        list: [
          str("signup_how_to_list1"),
          str("signup_how_to_list2"),
          str("signup_how_to_list3"),
        ],
      },
      faq: {
        title: str("signup_faq_title"),
        test: [
          {
            question: str("question_test"),
          },
        ],
      },
    },
  };

  const promobotData = {
    intro_img: Innovative,
    intro_title: "promobot_feature1_title",
    intro_text: "promobot_feature1_text",
    intro_carousel: "promobotCarousel",
    specifications: {
      title: "Specifications",
      img: PromoBot,
      detail: [
        {
          key: "Machine Dimensions:",
          value: "451mmx436mmx1103mm",
        },
        {
          key: "Machine Weight:",
          value: "38kg",
        },
        {
          key: "Carrying Capacity:",
          value: "30kg",
        },
        {
          key: "Battery Life:",
          value: ">8h",
        },
        {
          key: "Charging Time:",
          value: "4.5h",
        },
        {
          key: "Clearance:",
          value: "55cm",
        },
        {
          key: "Ad Display Dimensions:",
          value: "18.5”",
        },
      ],
    },
    features: [
      {
        img: Specialized,
        title: "promobot_feature2_title",
        text: ["promobot_feature2_text"],
      },
      {
        img: Smart,
        title: "promobot_feature3_title",
        text: ["promobot_feature3_text"],
      },
      {
        video: "https://player.vimeo.com/video/642530635?h=ee68e1e00d",
        title: "promobot_feature4_title",
        text: ["promobot_feature4_text"],
      },
    ],
    use_cases: [
      {
        img: Dining,
        title: "Automated Dining",
        link: "/use-case-dining-automation",
      },
      {
        img: Casino,
        title: "Casinos",
        link: "/use-case-casino-food-drink-automation",
      },
      {
        img: Retail,
        title: "Retail Stores",
        link: "/use-case-retail-store-automation",
      },
    ],
  };
  const pudubotData = {
    intro_img: Intelligent,
    intro_title: "pudubot_feature1_title",
    intro_text: "pudubot_feature1_text",
    intro_carousel: "pudubotCarousel",
    specifications: {
      title: "Specifications",
      img: PuduSpecification,
      detail: [
        {
          key: str("machine_dimensions") + ":",
          value: "516x500x1288mm",
        },
        {
          key: "Machine Weight:",
          value: "35kg",
        },
        {
          key: "Carrying Capacity:",
          value: "30kg",
        },
        {
          key: "Battery Life:",
          value: ">10h",
        },
        {
          key: "Charging Time:",
          value: "4h",
        },
        {
          key: "Cruise Speed:",
          value: "0.5-1.2 m/s",
        },
      ],
    },
    features: [
      {
        img: Superior,
        title: "pudubot_feature2_title",
        list: [
          "pudubot_feature2_text_list1",
          "pudubot_feature2_text_list2",
          "pudubot_feature2_text_list3",
          "pudubot_feature2_text_list4",
          "pudubot_feature2_text_list5",
          "pudubot_feature2_text_list6",
        ],
      },
      {
        img: Obstacle,
        title: "pudubot_feature3_title",
        text: ["pudubot_feature3_text"],
      },
      {
        img: Works,
        title: "pudubot_feature4_title",
        text: ["pudubot_feature4_text", "pudubot_feature4_text2"],
      },
    ],
    use_cases: [
      {
        img: Dining,
        title: "Automated Dining",
        link: "/use-case-dining-automation",
      },
      {
        img: Casino,
        title: "Casinos",
        link: "/use-case-casino-food-drink-automation",
      },
      {
        img: Hotel,
        title: "Hotel",
        link: "/use-case-hotel-service-automation",
      },
    ],
  };
  const flashbotData = {
    intro_img: FlashNextGeneration,
    intro_title: "flashbot_feature1_title",
    intro_text: "flashbot_feature1_text",
    intro_hero_img: FlashTop,
    specifications: {
      title: "Specifications",
      img: FlashSpec,
      detail: [
        {
          key: "Machine Dimensions:",
          value: "539x515x1050mm",
        },
        {
          key: "Machine Weight:",
          value: "50kg",
        },
        {
          key: "Carrying Capacity:",
          value: "30kg",
        },
        {
          key: "Compartment Space:",
          value: "2-4 (Adjustable)",
        },
        {
          key: "Compartment Dimensions (Single):",
          value: "219x410x286mm",
        },
        {
          key: "Compartment Dimensions (Double):",
          value: "438x410x286mm",
        },
        {
          key: "Battery Life:",
          value: ">10h",
        },
        {
          key: "Charging Time:",
          value: "4.5h",
        },
      ],
    },
    features: [
      {
        img: FlashSpecialized,
        title: "flashbot_feature2_title",
        text: ["flashbot_feature2_text"],
      },
      {
        img: Safe,
        title: "flashbot_feature3_title",
        text: ["flashbot_feature3_text"],
      },
    ],
    use_cases: [
      {
        img: Hotel,
        title: "Hotel",
        link: "/use-case-hotel-service-automation",
      },
      {
        img: Casino,
        title: "Casinos",
        link: "/use-case-casino-food-drink-automation",
      },
      {
        img: Retail,
        title: "Retail Stores",
        link: "/use-case-retail-store-automation",
      },
    ],
  };
  const disinfectionData = {
    intro_img: DisinfectionRobot,
    intro_title: "disinfection_feature1_title",
    intro_text: "disinfection_feature1_text",
    intro_carousel: "disinfectiontCarousel",
    specifications: {
      title: "Specifications",
      img: DisinfectionRobot,
      detail: [
        {
          key: "Machine Dimensions:",
          value: "544x538x1290mm",
        },
        {
          key: "Machine Weight:",
          value: "60kg",
        },
        {
          key: "Reservoir Capacity:",
          value: "15L",
        },
        {
          key: "Disinfection Time:",
          value: "Max 6H",
        },
        {
          key: "Effective Disinfection Distance:",
          value: "3 meters",
        },
        {
          key: "Motion Sensor: ",
          value: "Yes",
        },
      ],
    },
    features: [
      {
        img: MultiDisinfection,
        title: "disinfection_feature2_title",
        sub_title: [
          "disinfection_feature2_sub_title1",
          "disinfection_feature2_sub_title2",
        ],
        list: [
          "disinfection_feature2_text_list1",
          "disinfection_feature2_text_list2",
          "disinfection_feature2_text_list3",
          "disinfection_feature2_text_list4",
        ],
      },
      {
        img: DisinfectionSensors,
        title: "disinfection_feature3_title",
        text: ["disinfection_feature3_text"],
      },
      {
        img: DisinfectionCharge,
        title: "disinfection_feature4_title",
        text: ["disinfection_feature4_text"],
      },
    ],
    use_cases: [
      {
        img: Hotel,
        title: "Hotel",
        link: "/use-case-hotel-service-automation",
      },
      {
        img: Casino,
        title: "Casinos",
        link: "/use-case-casino-food-drink-automation",
      },
      {
        img: Hospital,
        title: "Hospital",
        link: "#",
      },
    ],
  };
  const bellabotData = {
    intro_img: BellaIntro,
    intro_title: "bellabot_feature1_title",
    intro_text: "bellabot_feature1_text",
    intro_carousel: "bellabotCarousel",
    features: [
      {
        img: GuestInter,
        title: "bellabot_feature2_title",
        list: [
          "bellabot_feature2_text_list1",
          "bellabot_feature2_text_list2",
          "bellabot_feature2_text_list3",
          "bellabot_feature2_text_list4",
        ],
      },
      {
        img: BellaBotFood,
        title: "bellabot_feature3_title",
        list: [
          "bellabot_feature3_text_list1",
          "bellabot_feature3_text_list2",
          "bellabot_feature3_text_list3",
          "bellabot_feature3_text_list4",
        ],
      },
      {
        video: "https://player.vimeo.com/video/642529933?h=b539d7ac59",
        title: "bellabot_feature4_title",
        list: [
          "bellabot_feature4_text_list1",
          "bellabot_feature4_text_list2",
          "bellabot_feature4_text_list3",
        ],
      },
      {
        img: BellaBotSpec,
        title: "bellabot_feature5_title",
        list: [
          "bellabot_feature5_text_list1",
          "bellabot_feature5_text_list2",
          "bellabot_feature5_text_list3",
        ],
      },
    ],
    use_cases: [
      {
        img: Dining,
        title: "Automated Dining",
        link: "/use-case-dining-automation",
      },
      {
        img: Casino,
        title: "Casinos",
        link: "/use-case-casino-food-drink-automation",
      },
      {
        img: Retail,
        title: "Retail Stores",
        link: "/use-case-retail-store-automation",
      },
    ],
  };
  const robotsData = [
    {
      img: PuduBot,
      title: "PuduBot",
      text: "Fast and easy food delivery robot",
      link: "/pudubot-food-delivery-robot",
    },
    {
      img: DisinfectionRobot,
      title: "DisinfectionBot",
      text: "Highly efficient and autonomous sanitation robot",
      link: "/disinfectionbot-autonomous-disinfection-robot",
    },
    {
      img: BellaBot,
      title: "BellaBot",
      text: "Cute, Likeable, and Smart Delivery Robot",
      link: "/bellabot-restaurant-delivery-robot",
    },
    {
      img: PromoBot,
      title: "PromoBot",
      text: "High-Resolution Front Facing Screen robot with AI Voice Interaction",
      link: "/promobot-promotional-delivery-robot",
    },
    {
      img: FlashBot,
      title: "FlashBot",
      text: "Building delivery robot capable of taking elevators",
      link: "/flashbot-building-delivery-robot",
    },
  ];

  const termsConditionsData = {
    header: {
      title: str("conditions_of_use"),
      text: str("terms_and_conditions_header_text"),
    },
    contents: [
      {
        title: str("terms_and_conditions_contents1_title"),
        text: str("terms_and_conditions_contents1_text"),
      },
      {
        title: str("terms_and_conditions_contents2_title"),
        text: str("terms_and_conditions_contents2_text"),
      },
      {
        title: str("terms_and_conditions_contents3_title"),
        text: str("terms_and_conditions_contents3_text"),
      },
      {
        title: str("terms_and_conditions_contents4_title"),
        text: str("terms_and_conditions_contents4_text"),
      },
      {
        title: str("terms_and_conditions_contents5_title"),
        text: str("terms_and_conditions_contents5_text"),
      },
      {
        title: str("terms_and_conditions_contents6_title"),
        text: str("terms_and_conditions_contents6_text"),
      },
      {
        title: str("terms_and_conditions_contents7_title"),
        text: str("terms_and_conditions_contents7_text"),
      },
      {
        title: str("terms_and_conditions_contents8_title"),
        text: str("terms_and_conditions_contents8_text"),
      },
      {
        title: str("terms_and_conditions_contents9_title"),
        text: str("terms_and_conditions_contents9_text"),
      },
      {
        title: str("terms_and_conditions_contents10_title"),
        text: str("terms_and_conditions_contents10_text"),
      },
      {
        title: str("terms_and_conditions_contents11_title"),
        text: str("terms_and_conditions_contents11_text"),
      },
      {
        title: str("terms_and_conditions_contents12_title"),
        text: str("terms_and_conditions_contents12_text"),
      },
      {
        title: str("terms_and_conditions_contents13_title"),
        text: str("terms_and_conditions_contents13_text"),
      },
      {
        title: str("terms_and_conditions_contents14_title"),
        text: str("terms_and_conditions_contents14_text"),
      },
      {
        title: str("terms_and_conditions_contents15_title"),
        text: str("terms_and_conditions_contents15_text"),
      },
      {
        title: str("terms_and_conditions_contents16_title"),
        text: str("terms_and_conditions_contents16_text"),
      },
      {
        title: str("terms_and_conditions_contents17_title"),
        text: str("terms_and_conditions_contents17_text"),
      },
      {
        title: str("terms_and_conditions_contents18_title"),
        text: str("terms_and_conditions_contents18_text"),
      },
      {
        title: str("terms_and_conditions_contents19_title"),
        text: str("terms_and_conditions_contents19_text"),
      },
      {
        title: str("terms_and_conditions_contents20_title"),
        text: str("terms_and_conditions_contents20_text"),
      },
      {
        title: str("terms_and_conditions_contents21_title"),
        text: str("terms_and_conditions_contents21_text"),
      },
      {
        title: str("terms_and_conditions_contents22_title"),
        text: str("terms_and_conditions_contents22_text"),
      },
      {
        title: str("terms_and_conditions_contents23_title"),
        text: str("terms_and_conditions_contents23_text"),
      },
    ],
    notice: {
      title: str("terms_and_conditions_notice_title"),
      text: str("terms_and_conditions_notice_text"),
      list: [
        str("terms_and_conditions_notice_list1"),
        str("terms_and_conditions_notice_list2"),
        str("terms_and_conditions_notice_list3"),
        str("terms_and_conditions_notice_list4"),
        str("terms_and_conditions_notice_list5"),
        str("terms_and_conditions_notice_list6"),
      ],
      p: str("terms_and_conditions_notice_p"),
      oneItem: str("terms_and_conditions_notice_oneItem"),
      subtext: str("terms_and_conditions_notice_subtext"),
    },
    additional: {
      title: str("terms_and_conditions_additional_title"),
      list: [
        str("terms_and_conditions_additional_list1"),
        str("terms_and_conditions_additional_list2"),
        str("terms_and_conditions_additional_list3"),
        str("terms_and_conditions_additional_list4"),
      ],
    },
  };
  const privacyPolicyData = {
    header: {
      title: str("privacy_policy_header_title"),
      text: str("privacy_policy_header_text"),
    },
    contents: [
      {
        title: str("privacy_policy_ontents1_title"),
        text: str("privacy_policy_ontents1_text"),
      },
      {
        title: str("privacy_policy_ontents2_title"),
        text: str("privacy_policy_ontents2_text"),
      },
      {
        title: str("privacy_policy_ontents3_title"),
        text: str("privacy_policy_ontents3_text"),
      },
      {
        title: str("privacy_policy_ontents4_title"),
        text: str("privacy_policy_ontents4_text"),
      },
      {
        title: str("privacy_policy_ontents5_title"),
        text: str("privacy_policy_ontents5_text"),
      },
      {
        title: str("privacy_policy_ontents6_title"),
        text: str("privacy_policy_ontents6_text"),
      },
      {
        title: str("privacy_policy_ontents7_title"),
        text: str("privacy_policy_ontents7_text"),
      },
      {
        title: str("privacy_policy_ontents8_title"),
        text: str("privacy_policy_ontents8_text"),
      },
      {
        title: str("privacy_policy_ontents9_title"),
        text: str("privacy_policy_ontents9_text"),
      },
      {
        title: str("privacy_policy_ontents10_title"),
        text: str("privacy_policy_ontents10_text"),
      },
      {
        title: str("privacy_policy_ontents11_title"),
        text: str("privacy_policy_ontents11_text"),
      },
      {
        title: str("privacy_policy_ontents12_title"),
        text: str("privacy_policy_ontents12_text"),
      },
      {
        title: str("privacy_policy_ontents13_title"),
        text: str("privacy_policy_ontents13_text"),
      },
    ],
  };

  const tableData = {
    tableTitle: {
      col1: "Operational Costs",
      col2: "Self-Serve-Ordering",
      col3: "Traditional Staff Served Ordering",
    },
    tableContents: [
      {
        row: 1,
        content: {
          col1: "Menu cost",
          col2: "0",
          col3: "$0.1-$0.2/person",
        },
      },
      {
        row: 2,
        content: {
          col1: "Wait time to receive menu from staff",
          col2: "0",
          col3: "1-6 min",
        },
      },
      {
        row: 3,
        content: {
          col1: "Staff time on each order and item input",
          col2: "0",
          col3: "2-10 min",
        },
      },
      {
        row: 4,
        content: {
          col1: "Wait time to get bill and pay bill",
          col2: "0*",
          col3: "3-15 min",
        },
      },
      {
        row: 5,
        content: {
          col1: "Tips received",
          col2: "On average 5% more than staff served ordering",
          col3: "0-20%",
        },
      },
      {
        row: 6,
        content: {
          col1: "Rewards & Customer loyalty program",
          col2: "Automated, built-in",
          col3: "Manual collection by staff, error-prone",
        },
      },
      {
        row: 7,
        content: {
          col1: "Customer experience",
          col2: "Better",
          col3: "Good",
        },
      },
      {
        row: 8,
        content: {
          col1: "Customer data",
          col2: "Automatically collected",
          col3: "N/A",
        },
      },
      {
        row: 9,
        content: {
          col1: "Total staff time on each order**",
          col2: "0",
          col3: "5-15 min",
        },
      },
      {
        row: 10,
        content: {
          col1: "Cost for menu update***",
          col2: "0",
          col3: "$100-$1,000",
        },
      },
      {
        row: 11,
        content: {
          col1: "Convert to pickup/delivery order",
          col2: "Quick and simple, just a few taps on your mobile device",
          col3: "Phone call to be answered by a staff",
        },
      },
      {
        row: 12,
        content: {
          col1: "Cost for each order",
          col2: "< $0.25",
          col3: "> $2 per order",
        },
      },
    ],
  };

  const goDigital = {
    hero: {
      subtitle1: str("grant_hero_subtitle_1"),
      titleWhite: str("grant_hero_title_white"),
      titleYellow: str("grant_hero_title_yellow"),
      subtitle2: str("grant_hero_subtitle_2"),
    },
    contents: {
      para1: str("grant_para_1"),
      para2: str("grant_para_2"),
      para3Title: str("grant_eligibility"),
      para3: str("grant_eligibility_para"),
      para4Title: str("grant_costs_covered_by_grant"),
      para4: str("grant_costs_covered_by_grant_para"),
      para4ListItem: [
        str("grant_costs_covered_by_grant_li_1"),
        str("grant_costs_covered_by_grant_li_2"),
        str("grant_costs_covered_by_grant_li_3"),
      ],
      para5Title: str("grant_what_goopter_will_do"),
      para5: str("grant_what_goopter_will_do_para"),
      para5List1: str("grant_what_goopter_will_do_li_1"),
      para5List2: str("grant_what_goopter_will_do_li_2"),
      para5List3: str("grant_what_goopter_will_do_li_3"),
      para5List1Item: [
        str("grant_what_goopter_will_do_li_1_1"),
        str("grant_what_goopter_will_do_li_1_2"),
        str("grant_what_goopter_will_do_li_1_3"),
      ],
      para5List2Item: [
        str("grant_what_goopter_will_do_li_2_1"),
        str("grant_what_goopter_will_do_li_2_2"),
        str("grant_what_goopter_will_do_li_2_3"),
        str("grant_what_goopter_will_do_li_2_4"),
      ],
      button: str("grant_button"),
    },
    form: {
      title: str("grant_form_title"),
      header: str("grant_form_header"),
      select: str("grant_form_select"),
      options: [
        str("grant_form_option_1"),
        str("grant_form_option_2"),
        str("grant_form_option_3"),
        str("grant_form_option_4"),
        str("grant_form_option_5"),
        str("grant_form_option_6"),
        str("grant_form_option_7"),
        str("grant_form_option_8"),
      ],
      submitted: str("grant_form_submitted"),
      submittedMessage: str("grant_form_submitted_message"),
      submittedButton: str("grant_form_submitted_button"),
    },
  };

  const techUp = {
    hero: {
      subtitle1: str("techup_grant_hero_subtitle_1"),
      titleWhite: str("techup_grant_hero_title_white"),
      titleYellow: str("techup_grant_hero_title_yellow"),
    },
    contents: {
      para1_1: str("techup_grant_para_1_1"),
      para1_2: str("techup_grant_para_1_2"),
      para1_3: str("techup_grant_para_1_3"),
      para2: str("techup_grant_para_2"),
      para3Title: str("techup_grant_eligibility"),
      para3_1: str("techup_grant_eligibility_para_1"),
      para3_2: str("techup_grant_eligibility_para_2"),
      para4Title: str("techup_grant_costs_covered_by_grant"),
      para4: str("techup_grant_costs_covered_by_grant_para"),
      para4ListItem: [
        str("techup_grant_costs_covered_by_grant_li_1"),
        str("techup_grant_costs_covered_by_grant_li_2"),
        str("techup_grant_costs_covered_by_grant_li_3"),
        str("techup_grant_costs_covered_by_grant_li_4"),
      ],
      para5Title: str("techup_grant_what_goopter_will_do"),
      para5: str("techup_grant_what_goopter_will_do_para"),
      para5List1: str("techup_grant_what_goopter_will_do_li_1"),
      para5List2: str("techup_grant_what_goopter_will_do_li_2"),
      para5List3: str("techup_grant_what_goopter_will_do_li_3"),
      para5List1Item: [
        str("techup_grant_what_goopter_will_do_li_1_1"),
        str("techup_grant_what_goopter_will_do_li_1_2"),
        str("techup_grant_what_goopter_will_do_li_1_3"),
      ],
      para5List2Item: [
        str("techup_grant_what_goopter_will_do_li_2_1"),
        str("techup_grant_what_goopter_will_do_li_2_2"),
        str("techup_grant_what_goopter_will_do_li_2_3"),
        str("techup_grant_what_goopter_will_do_li_2_4"),
      ],
      button: str("grant_button"),
    },
    form: {
      title: str("techup_grant_form_title"),
      header: str("techup_grant_form_header"),
      select: str("techup_grant_form_select"),
      options: [
        str("techup_grant_form_option_1"),
        str("techup_grant_form_option_2"),
        str("techup_grant_form_option_3"),
        str("techup_grant_form_option_4"),
        str("techup_grant_form_option_5"),
        str("techup_grant_form_option_6"),
        str("techup_grant_form_option_7"),
        str("techup_grant_form_option_8"),
      ],
      submitted: str("techup_grant_form_submitted"),
      submittedMessage: str("techup_grant_form_submitted_message"),
      submittedButton: str("techup_grant_form_submitted_button"),
    },
  };

  const grants = {
    card1: {
      title: str("card1_title"),
      subtitleWhite: str("card1_subtitle_white"),
      subtitleYellow: str("card1_subtitle_yellow"),
    },
    card2: {
      title: str("card2_title"),
      subtitle: str("card2_subtitle"),
    },
    card3: {
      title: str("card3_title"),
      subtitleWhite: str("card3_subtitle_white"),
      subtitleYellow: str("card3_subtitle_yellow"),
    },
  };



  return eval(name);
}
